/**
 * @file 简体中文话术
 * @author zhujialu
 */
define(function (require, exports) {
    'use strict'

    /**
     * =================================================
     * 用户角色
     * =================================================
     */

    exports.USER_ROLE_TEACHER = 'teacher'

    exports.USER_ROLE_STUDENT = 'siswa'

    exports.USER_ROLE_GUEST = 'turis'

    exports.USER_ROLE_ASSISTANT = 'asisten'

    exports.USER_ROLE_SPECIAL_GUEST = 'tamu terkenal'

    exports.USER_ASSISTANT_NUMBER = 'asisten Pengajar ${number}'

    /**
     * =================================================
     * 老师状态
     * =================================================
     */

    exports.TEACHER_UNKNOW = 'guru tidak masuk ke kelas'

    exports.TEACHER_IN = 'guru telah masuk ke kelas'

    exports.TEACHER_OUT = 'guru telah meninggalkan kelas'

    exports.TEACHER_AUDIO_ON = 'guru telah menyalakan mikrofon'

    exports.TEACHER_AUDIO_OFF = 'guru telah mematikan mikrofon'

    exports.TEACHER_VIDEO_ON = 'the teacher has turned on the camera'

    exports.TEACHER_VIDEO_OFF = 'guru telah mematikan kamera'

    /**
     * =================================================
     * 用户状态
     * =================================================
     */

    exports.USER_OUT = 'ta telah meninggalkan kelas'

    exports.USER_AUDIO_ON = 'mikrofon menyala'

    exports.USER_AUDIO_OFF = 'mikrofon mati'

    exports.USER_VIDEO_ON = 'kamera menyala'

    exports.USER_VIDEO_OFF = 'kamera mati'

    /**
     * =================================================
     * 自己状态
     * =================================================
     */

    exports.SELF_AUDIO_ON = 'mikrofon menyala'

    exports.SELF_AUDIO_OFF = 'mikrofon mati'

    exports.SELF_VIDEO_ON = 'kamera menyala'

    exports.SELF_VIDEO_OFF = 'kamera mati'

    /**
     * =================================================
     * 画质
     * =================================================
     */

    exports.VIDEO_QUALITY_LOW = 'fluent'

    exports.VIDEO_QUALITY_MEDIUM = 'aman'

    exports.VIDEO_QUALITY_HIGH = 'definisi tinggi'

    exports.VIDEO_QUALITY_SUPER = 'chaoqing'

    exports.VIDEO_QUALITY_720p = '720p'

    exports.VIDEO_QUALITY_1080p = '1080p'

    /**
     * =================================================
     * 百家云终端类型
     * =================================================
     */

    exports.END_TYPE_PC_BROWSER_BJY = 'halaman web komputer'

    exports.END_TYPE_PC_CLIENT_BJY = 'klien pc'

    exports.END_TYPE_MAC_CLIENT_BJY = 'klien mac'

    exports.END_TYPE_MOBILE_BROWSER_BJY = 'versi web ponsel'

    exports.END_TYPE_MOBILE_XIAOCHENGXU = 'aplet wechat'

    exports.END_TYPE_MOBILE_APPLE_BJY = 'apple app'

    exports.END_TYPE_MOBILE_ANDROID_BJY = 'aplikasi android'

    exports.END_TYPE_MINI_PROGRAM_BJY = 'aplet'

    exports.END_TYPE_WEBRTC_BJY = 'bisa berada di wheat'

    exports.END_TYPE_UNKNOWN_BJY = 'tidak diketahui'

    /**
     * =================================================
     * 音视频链路状态
     * =================================================
     */

    exports.AV_PLAY_STATUS_CONNECTING = 'membuat hubungan dengan pihak lain'

    exports.AV_PLAY_STATUS_FAIL = 'gagal membuat koneksi'

    exports.AV_PLAY_STATUS_BUFFERING = 'penyembah data'

    /**
     * =================================================
     * 快捷键
     * =================================================
     */

    exports.SHORTCUT_EXIT_FULLSCREEN = 'untuk keluar dari layar penuh, tekan esc'

    /**
     * =================================================
     * 按钮
     * =================================================
     */

    exports.BUTTON_SUBMIT = 'menentukan'

    exports.BUTTON_CLOSE = 'tutup'

    exports.BUTTON_CANCEL = 'batalkan'

    exports.BUTTON_ACCEPT = 'setuju!'

    exports.BUTTON_REJECT = 'menolak'

    exports.BUTTON_REFRESH = 'segar'

    exports.BUTTON_TRY_REFRESH = 'segar dan coba lagi'

    exports.BUTTON_CLOSE_ROOM = 'hentikan siaran'

    exports.BUTTON_REENTER = 'masuk kembali ke kelas'

    exports.BUTTON_LEAVE = 'keluar dari kelas'

    exports.BUTTON_START_CLASS = 'menghadiri kelas;kelas dimulai'

    exports.BUTTON_START_CLASS_FOR_SELL = 'mulai menunjukkan'

    exports.BUTTON_END_CLASS = 'kelas berakhir'

    exports.BUTTON_END_CLASS_FOR_SELL = 'downcast'

    exports.BUTTON_LEAVE_CLASS_AND_REMOVE_ALL = 'tinggalkan dan menghapus siswa'

    exports.BUTTON_END_CLASS_AND_REMOVE_ALL = 'kelas berakhir dan siswa dihapus'

    exports.BUTTON_STOP_RTMP_PUSH = 'tidak ada siaran'

    exports.BUTTON_PLAY_MEDIA = 'main'

    exports.BUTTON_RECORD_CLASS = 'rekam kursus'

    exports.BUTTON_START_RECORD_CLASS = 'mulai'

    exports.BUTTON_STOP_RECORD_CLASS = 'hentikan merekam'

    exports.BUTTON_RESTART_RECORD_CLASS = 'teruskan'

    exports.BUTTON_RECORD_FULLSCREEN = 'rekam layar penuh'

    exports.BUTTON_RECORD_AREA = 'rekam kursus daerah'

    exports.BUTTON_START_SCREEN_SHARE = 'pembahagian layar'

    exports.BUTTON_QUESTION_ANSWER = 'q & a'

    exports.BUTTON_EXAM = 'penelitian teks tentang suitang'
    exports.BUTTON_END_EXAM = 'tutup pemeriksaan'

    exports.BUTTON_STOP_SCREEN_SHARE = 'akhir'

    exports.BUTTON_RECORD_SETTINGS = 'menetapkan rekaman tentu saja'

    exports.BUTTON_THIRD_PUSH = 'dorong layanan streaming'

    exports.BUTTON_FORBID_MIC = 'prosody'

    exports.BUTTON_CANCEL_FORBID_MIC = 'batalkan larangan'

    exports.BUTTON_SURVEY = 'tes'

    exports.BUTTON_LOTTERY = 'gambar keberuntungan'

    exports.BUTTON_ANSWER = 'mesin jawab'

    exports.BUTTON_DEBUG = 'debugging'

    exports.BUTTON_TIMER = 'timer'

    exports.BUTTON_RED_PACKET = 'hujan sampul merah'

    exports.BUTTON_ENTER_FULLSCREEN = 'layar penuh'

    exports.BUTTON_EXIT_FULLSCREEN = 'keluar layar penuh'

    exports.BUTTON_OPEN_CAMERA = 'tidak terbuka'

    exports.BUTTON_CLOSE_CAMERA = 'hidupkan'

    exports.BUTTON_OPEN_MIC = 'tidak terbuka'

    exports.BUTTON_CLOSE_MIC = 'hidupkan'

    exports.BUTTON_SPEAK_APPLY = 'angkat tangan'

    exports.BUTTON_SPEAK_APPLY_CANCEL = 'batalkan'

    exports.BUTTON_END_SPEAK = 'akhir'

    exports.BUTTON_MANAGE_DOCUMENT = 'jalurku'

    exports.BUTTON_ADD_DOCUMENT = 'tambah ke'

    exports.BUTTON_REMOVE_DOCUMENT = 'hapus'

    exports.BUTTON_DELETE_DOCUMENT = 'hapus'

    exports.BUTTON_SUBMIT_DOCUMENT = 'konfirmasi pemilihan'

    exports.BUTTON_ADD_DOCUMENT_FORM_NETDESK = 'pemilihan pangkalan data'

    exports.BUTTON_UPLOAD_DOCUMENT = 'jalur umum'

    exports.BUTTON_SEND_MESSAGE = 'kirim keluar'

    exports.BUTTON_GIFT = 'serahkan minuman'

    exports.BUTTON_EDIT_NOTICE = 'pengumuman editorial'

    exports.BUTTON_SAVE_NOTICE = 'simpan pengumuman'

    exports.BUTTON_SWITCH_GIFT = 'ubah cangkir'

    exports.BUTTON_SEND_GIFT_TO_TEACHER = 'untuk guru'

    exports.BUTTON_FORBID_USER_SEND_MESSAGE = 'tidak ada chat ta'

    exports.BUTTON_UNFORBID_USER_SEND_MESSAGE = 'buang larangan pada ta'

    exports.BUTTON_SURVEY_ADD_OPTION = 'tambah opsi'

    exports.BUTTON_NEED = 'butuh'

    exports.BUTTON_NO_NEED = 'tidak diinginkan'

    exports.BUTTON_REPLY_SUBMIT = 'konfirmasi jawabannya'

    exports.BUTTON_MINIMIZE = 'minimize'

    exports.BUTTON_HELP = 'cari bantuan'

    exports.BUTTON_ASSISTANT_LINK = 'links to teaching assistants'

    exports.BUTTON_JOIN_USERLIST = 'daftar peserta'

    exports.BUTTON_ATTENTION_DETECTION = 'concentration test'

    exports.BUTTON_GEN_LINK = 'hasilkan hubungan'

    exports.BUTTON_COPY_LINK = 'salin'

    exports.BUTTON_COPY_LINK_SUCC = 'sukses'

    exports.BUTTON_COMMENT = 'evaluasi'

    exports.BUTTON_DETECT = 'tes'

    exports.BUTTON_MORE = 'lebih'

    exports.BUTTON_NEXT_STEP = 'langkah berikutnya'

    exports.BUTTON_COMPLETE = 'selesai'

    exports.BUTTON_COMMENT_SUBMIT = 'kirim komentar'

    exports.BUTTOM_COMMENT_SEND = 'evaluasi guru'

    exports.BUTTON_COMMENT_CANCEL = 'saya tidak komentar'

    exports.BUTTON_SHOW_LOGS = 'tambah log'

    exports.BUTTON_HIDE_LOGS = 'letakkan log'

    exports.BUTTON_RETURN = 'kembali'

    exports.BUTTON_SERVER_ROUTE = 'baris'

    exports.BUTTON_SERVER_SUGGEST = 'rute yang disukai'

    exports.BUTTON_SERVER_BACKUP = 'rute alternatif'

    exports.BUTTON_SWITCH_TO_ONLINE = 'manifest dirimu sendiri'

    exports.BUTTON_SWITCH_TO_OFFLINE = 'tidak terlihat'

    exports.BUTTON_MODIFY = 'perubahan'

    exports.BUTTON_UNFORBID_ALL = 'buang larangan'

    exports.BUTTON_COMMENT_REQ_MORE = 'lihat lagi'

    exports.BUTTON_COMMENT_NO_MORE = 'setelah semua'

    exports.BUTTON_UPGRADE_CLIENT = 'upgrade versi baru'

    exports.BUTTON_USE_GUIDE = 'tutorial klien'

    exports.BUTTON_SWITCH_OPEN = 'buka'

    exports.BUTTON_SWITCH_CLOSE = 'tutup'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ME = 'lihatlah aku.'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_TEACHER = 'lihatlah guru.'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ALL = 'seluruh'

    exports.BUTTON_SETTING_MORE_DETAIL = 'more settings'

    exports.BUTTON_BARRAGE_ON = 'barage terbuka'

    exports.BUTTON_BARRAGE_OFF = 'penghalang lewat'

    exports.BUTTON_SYSTEM_SOUND = 'suara sistem'

    exports.BUTTON_SWITCH_LAYOUT = 'tukar layout'

    exports.BUTTON_FORBID_RAISE_HAND_OFF = 'tangan di atas diperbolehkan'

    exports.BUTTON_FORBID_RAISE_HAND_ON = 'tidak ada tangan'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_OFF = 'students are allowed to raise their hands'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_ON = 'para mahasiswa tidak diizinkan untuk mengangkat tangan mereka'

    exports.BUTTON_SELL_PRODUCT = 'komoditas'

    exports.BUTTON_SHOP = 'mobil belanja'

    exports.BUTTON_SELL_VIDEO_LAYOUT = 'Template Video Murni'

    exports.BUTTON_SELL_PPT_LAYOUT = 'Template Penjualan PPT'

    exports.BUTTON_HOMEWORK = 'area operasi'

    exports.BUTTON_CONFIRM_CANCEL_SCREEN_SHARE_BITRATE_CHANGE = 'tidak untuk saat ini'

    exports.BUTTON_CONFIRM_OK_SCREEN_SHARE_BITRATE_CHANGE = 'bagi ulang'

    exports.BUTTON_TOGGLE_VIDEO_AND_DOC = 'tukar jendela'

    exports.BUTTON_MAIN_SCREEN_NOTICE = 'pengumuman layar utama'

    exports.BUTTON_ASSISTANT_OPTIONS = 'mengajar operasi asisten'

    exports.BUTTON_USER_AUTH_INFO = 'tampilkan keizinan'

    exports.BUTTON_REPORT = 'laporan'

    exports.BUTTON_REWARD_RANKING = 'penghargaan'

    exports.BUTTON_RUSH_TO_ANSWER = 'responder'

    exports.BUTTON_TRANSFER_CLASS_START = 'mulai rebroadcasting'

    exports.BUTTON_TRANSFER_CLASS_END = 'mengakhiri transmisi ulang'

    exports.BUTTON_GIFT_ANIMATION = 'efek khusus hadiah'

    exports.BUTTON_HIDE_GIFT_ANIMATION = 'perisai efek khusus'

    exports.BUTTON_SHOW_GIFT_ANIMATION = 'tampilkan efek khusus'

    exports.BUTTON_REWARDS = 'Hadiah'

    exports.BUTTON_REWARDS_STATISTICS = 'Statistik pendapatan'

    exports.BUTTON_LUCKY_BAG = 'Kantong'

    exports.BUTTON_CASH_WITHDRAW = 'Angkat'

    exports.BUTTON_VIDEO_LAYOUT = 'Suai arus push-up'

    exports.BUTTON_ON_OFF_STAGE = 'bergilir di panggung'

    exports.BUTTON_ACTIVITY = 'aktivitas'

    exports.BUTTON_MESSAGE_CHECK = 'Tinjauan Sembang'

    exports.BUTTON_TURN_OFF_ALL_USERS = 'matikan semua'

    /**
     * =================================================
     * 标签
     * =================================================
     */

    exports.TAB_ALL_USER_LIST = 'pengguna'

    exports.TAB_ACTIVE_USER_LIST = 'daftar pembicara'

    exports.TAB_CHAT = 'percakapan'

    exports.TAB_ANSWER_LIST = 'q & a'

    exports.TAB_RESEARCH_GROUP = 'Research'

    exports.TAB_USER_LIST_HIDE = 'orang'

    exports.TAB_CLASS_STARTED = 'hidup'

    exports.TAB_TIME_SORT = 'Pengurusan Waktu'

    exports.ANSWER_SORT_TYPE_SUBMIT = 'Isi mengikuti waktu pengiriman'

    exports.ANSWER_SORT_TYPE_OPERATE = 'Isih mengikut waktu operasi'

    /**
     * =================================================
     * 普通提示
     * =================================================
     */

    exports.INFO_CLASS_START = 'kelas'

    exports.INFO_CLASS_END = 'kelas berakhir.'

    exports.INFO_SPEAK_APPLY_TIMEOUT
        = 'guru tidak menjawab untuk waktu yang lama, dan angkat tangan telah dibatalkan secara otomatis'

    exports.INFO_SPEAK_INVITE_TIMEOUT
        = '${userName} sudah lama tidak menjawab atau menggunakan klien versi lama, undangan telah dibatalkan'

    exports.INFO_SPEAK_OPEN_TIMEOUT
        = '${userName} sudah lama tidak menjawab atau menggunakan klien versi lama, dan secara otomatis membatalkan pidato pembukaan'

    exports.INFO_SPEAK_OPEN_SUCCESS
        = '${userName} telah dibuka untuk berbicara, Anda dapat pergi ke \'daftar pidato\' untuk melihat'

    exports.INFO_HAS_BEEN_OPENED_SPEAKING = 'guru telah mengatur untuk anda berbicara dengan suara'

    exports.INFO_HAS_BEEN_OPENED_WEBMIC = 'guru telah menyalakan mikrofon anda'

    exports.INFO_HAS_BEEN_CLOSED_WEBMIC = 'guru telah mematikan mikrofonmu'

    exports.INFO_HAS_BEEN_OPENED_WEBCAM = 'the teacher has turned on your camera'

    exports.INFO_HAS_BEEN_CLOSED_WEBCAM = 'guru telah mematikan kameramu'

    exports.INFO_OPEN_WEBCAM_FAILED = 'gagal membuka video. klik tombol untuk mencoba lagi'

    exports.INFO_WEAR_EARPHONE_WHEN_SPEAKING = 'untuk menghindari eko dan bersiul, pakai headphones'

    exports.INFO_RECEIVE_MESSAGE = 'kau punya berita.'

    exports.INFO_SPEAK_INVITE_ACCEPT = '${userName} telah setuju untuk berbicara'

    exports.INFO_SPEAK_INVITE_REJECT = '${userName} telah menolak untuk berbicara'

    exports.INFO_SPEAK_APPLY_ACCEPT = 'guru membiarkanmu berbicara'

    exports.INFO_SPEAK_APPLY_REJECT = 'silakan coba lagi nanti'

    exports.INFO_END_SPEAK_BY_TEACHER = 'guru menyelesaikan pidato anda'

    exports.INFO_DEVICE_IS_STARTING = 'perangkat audio dan video dimulai, tolong tunggu'

    exports.INFO_CAN_NOT_DO_BEFORE_END_SETTINGS = 'anda tidak bisa melakukan ini sampai anda selesai menetapkan'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_TEACHER = 'silakan klik tombol kelas pertama'

    exports.INFO_CAN_NOT_OPEN_CAMERA_AND_MIC = 'guru tidak diizinkan untuk menyalakan kamera dan mikrofon'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_STUDENT = 'jalan tidak dimulai'

    exports.INFO_CAN_NOT_DO_BEFORE_APPLY = 'tolong angkat tanganmu dulu.'

    exports.INFO_NO_AVAILABLE_CAMERA = 'tidak ada kamera tersedia'

    exports.INFO_NO_AVAILABLE_MIC = 'tidak ada mikrofon tersedia'

    exports.INFO_FORBID_SEND_MESSAGE_TO_OPERATOR = 'ta chat dinonaktifkan'

    exports.INFO_UNFORBID_SEND_MESSAGE_TO_OPERATOR = 'bantuan pada ta telah dibatalkan'

    exports.INFO_FORBID_SEND_MESSAGE_TO_TARGET = 'guru melarang anda untuk berbicara'

    exports.INFO_FORBID_SEND_MESSAGE_END = 'guru telah mengangkat laranganmu'

    exports.INFO_CLIENT_AUTO_UPGRADE = 'versi klienmu terlalu tua, meningkatkan secara otomatis'

    exports.INFO_CLIENT_NOT_SUPPORT = 'Tipe terminal tidak didukung, silakan gunakan versi terbaru klien untuk menonton'

    exports.INFO_SURVEY_REPLY_RIGHT = 'selamat, jawaban yang benar!!!'

    exports.INFO_SURVEY_REPLY_WRONG = 'oh, wrong answer'

    exports.INFO_SURVEY_REPLY_FREE = 'tidak ada jawaban untuk pertanyaan ini'

    exports.INFO_SURVEY_NO_QUESTION = '"tidak ada masalah stem, mungkin guru adalah oral"'

    exports.INFO_SURVEY_OPTION_HINT = 'klik opsi sunting'

    exports.INFO_SURVEY_CHOOSE_OPTION = '<span class="arrow">↙</span>check the correct answer'

    exports.INFO_SURVEY_SELF_CHOOSE = 'pilihanmu:'

    exports.INFO_COMMENT_SUCC = 'menghargai sukses'

    exports.INFO_COMMENT_BEFORE_CLASS = 'kumentar nanti'

    exports.INFO_APPLY_SPEAK_WOULD_DELAY_SOUND = 'mungkin ada keterlambatan suara ketika menggunakan versi web'

    exports.INFO_SPEAK_INVITE_DENY = 'jumlah pembicara penuh, silakan coba lagi nanti'

    exports.INFO_MEDIA_PUBLISH_DENY = 'jumlah pembicara penuh, silakan coba lagi nanti'

    exports.INFO_CAN_NOT_CLOSE_CAMERA = 'garis saat ini tidak menyediakan fungsi menutup video'

    // exports.INFO_SWITCH_SERVER_SUCCESS = '已切换至 ${0}';

    exports.INFO_SWITCH_SERVER_SUCCESS = 'bertukar'

    exports.INFO_FORBID_ALL = 'semua telah dilarang'

    exports.INFO_UNFORBID_ALL = 'semua larangan telah dibatalkan'

    exports.INFO_FORBID_GROUP_ALL = 'semua anggota kelompok ini telah dilarang'

    exports.INFO_UNFORBID_GROUP_ALL = 'kelompok ini telah membatalkan semua larangan'

    exports.INFO_SELF_ABROAD_TIPS
        = 'jika terdeteksi bahwa anda belajar di luar negeri, stabilitas jaringan transnasional mungkin tidak dijamin.<br/>'
        + 'silakan periksa untuk memastikan bahwa kecepatan kunjunganmu ke cina normal.'

    exports.INFO_TEACHER_ABROAD_TIPS
        = 'ditemukan bahwa guru mengajar di luar negeri, karena kompleksitas jaringan asing,<br/>'
        + 'audio dan video mungkin tidak stabil, silakan mengerti.'

    exports.INFO_OPEN_CAMERA = '${userRole} menyalakan kamera, data buffering'

    exports.INFO_OPEN_ASSIST_CAMERA = '${userRole} menyalakan kamera tambahan, data buffering'

    exports.INFO_CLOSE_CAMERA = 'matikan kameranya'

    exports.INFO_OPEN_MIC = '${userRole} menyalakan mikrofon, data buffering'

    exports.INFO_CLOSE_MIC = 'matikan mikrofonnya'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_SHARE_PLAY
        = 'silakan matikan pembagian layar dan pemain pertama dan berhenti mengirim aliran pihak ketiga'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CLOUD_RECORD = 'tipe uplink tidak dapat ditukar dalam rekaman kelas awan'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'tak bisa menyalakan kecantikan dalam mode hd, ultra jelas dan 1080p'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE
        = 'kecantikan tidak bisa diaktifkan dalam hd, ultra jelas, 720p, 1080p mode'

    exports.INFO_CLOUD_RECORD_START = 'pencatatan awan diaktifkan'

    exports.INFO_CLOUD_RECORD_STOP = 'pencatatan awan telah berhenti'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_THIRD_PUSH
        = 'sebelum berbagi layar, tolong berhenti mengirimkan streaming pihak ketiga'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_PLAY_FILE = 'tolong hentikan pemain berkas sebelum berbagi layar'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_SCREEN_SHARE = 'please stop sharing the screen before playing the file'

    exports.CONFIRM_STOP_ASSIST_CAMERA_BEFORE_MEDIA_PLAY
        = '<b>apakah anda ingin menyalakan media playback?</b>membuka media playback akan mematikan kamera sekunder.'

    exports.CONFIRM_STOP_MEDIA_PLAY_BEFORE_OPEN_ASSIST_CAMERA
        = '<b>apakah anda ingin menyalakan kamera bantuan?</b>menghidupkan kamera bantuan akan mematikan media playback.'

    exports.INFO_PLAY_LOCAL_MEDIA_FILE = 'main berkas lokal'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_THIRD_PUSH
        = 'silakan berhenti mengirim streaming pihak ketiga sebelum memainkan berkas lokal'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SCREEN_SHARE
        = 'please stop sharing the screen before forwarding the third party push stream'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_WHEN_COLLECT_SYSTEM_SOUND
        = 'berkas lokal tidak dapat dimainkan setelah mengumpulkan suara sistem'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_COLLECT_SYSTEM_SOUND
        = 'tolong batalkan sistem akuisisi suara pertama'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_PLAY_LOCAL_MEDIA_FILE
        = 'silakan tutup pemutaran berkas lokal dulu'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_MEDIA_FILE_PLAY
        = 'setelah bermain berkas lokal, anda tidak akan dapat mengumpulkan suara sistem'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SHARE_DESKTOP
        = 'please stop sharing the screen before forwarding the third party push stream'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START
        = 'pemutaran sedang dihasilkan. pencatatan awan tidak dapat digunakan dalam pelajaran ini'

    exports.INFO_CLOUD_RECORD_START_COUNT_WARNING = 'Sering menjeda dapat memengaruhi kualitas pemutaran. Silakan coba lagi nanti.'

    exports.INFO_GET_PLAYBACK_STATUS_FAIL = 'gagal mendapatkan status generasi pemutaran kembali, silakan coba lagi'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP
        = '<p class="large">apakah anda ingin mulai menghasilkan playback sekarang?</p> <p class="error">(setelah menghasilkan playback, rekaman awan tidak akan tersedia nanti dalam pelajaran ini.)</p>'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP_LONG_TERM
        = '<p class="large">apakah anda ingin mulai menghasilkan playback sekarang?</p>'

    exports.INFO_SEND_IMAGE_POST_DATA_ERROR = 'galat penghuraian data'

    exports.INFO_CAN_NOT_DETECT_DEVICE_DURING_SPEAKING = 'tolong berhenti bicara sebelum deteksi sistem'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CONSISTENSY
        = 'jenis link telah dikonfigurasi secara seragam. pengaturan ini tidak akan mengambil efek'

    exports.INFO_CLOSE_BARRAGE_TIP = 'jika anda perlu menggunakan berus, silakan matikan fungsi layar peluru pertama'

    exports.INFO_SETTING_FORBID_BY_CLASS_STARTED = 'seting ini tidak dapat diubah selama kelas'

    exports.INFO_RTMP_NOT_RUNNING = 'guru tidak mendorong aliran'

    exports.INFO_HAS_FORBID_MIC = 'semua mikrofon mati'

    exports.INFO_HAS_BEEN_MUTED = 'guru mematikan semua mikrofon'

    exports.INFO_MESSAGE_COPY_SUCCESS = 'kandungan percakapan berhasil disalin'

    exports.INFO_QA_COPY_SUCCESS = 'q & konten disalin dengan sukses'

    exports.INFO_QA_COPY_FAIL = 'gagal menyalin konten q & a. silakan menyalin secara manual'

    exports.INFO_PLAYER_PAUSE_BY_MIC_OFF = 'untuk terus bermain berkas, silakan nyalakan mikrofon anda'

    exports.INFO_USER_ACTIVE_ADD_DENY = 'jumlah pembicara penuh. silakan matikan audio dan video siswa lain dulu.'

    exports.INFO_ENROLL_START = 'registrasi dimulai'

    exports.CLASSROOM_COUNTDOWN_TITLE = 'siaran langsung dimulai dalam'

    exports.INFO_GIFT_ANIMATION_ENABLE = 'efek khusus hadiah dibuka'

    exports.INFO_GIFT_ANIMATION_DISABLE = 'efek khusus hadiah ditutup'

    exports.INFO_NO_CAMERA_OPERATION_PERMISSION = 'tidak ada izin operasi kamera'

    /**
     * =================================================
     * 空状态提示
     * =================================================
     */
    exports.INFO_NO_SPEAKER = 'tidak ada yang berbicara'

    /**
     * =================================================
     * 警告提示
     * =================================================
     */

    exports.WARNING_INPUT_FREQUENT = 'tolong jangan menggerakkan layar'

    exports.WARNING_INPUT_EMPTY = 'silakan masukkan isi percakapan'

    exports.WARNING_INPUT_OVERLENGTH = 'tolong jangan masukkan konten terlalu panjang'

    exports.WARNING_CAMERA_SWITCH_FREQUENT = 'tolong jangan nyalakan dan mematikan kamera sering'

    exports.WARNING_MIC_SWITCH_FREQUENT = 'tolong jangan sering menyalakan dan mematikan mikrofonnya.'

    exports.WARNING_CLOSE_DIALOG_ON_DOCUMENT_UPLOADING = 'jalurnya sedang diunggah, tolong tunggu sabar'

    exports.WARNING_SEND_MESSAGE_FORBID = 'anda telah dilarang berbicara'

    exports.WARNING_SURVEY_OPTION_HINT = 'klik huruf nomor seri untuk menetapkan jawaban yang benar'

    exports.WARNING_SURVEY_TEXTAREA_MAX = 'tolong jangan punya lebih dari 100 kata!'

    exports.WARNING_SURVEY_OPTION_MAX = 'tolong pilih tidak lebih dari 25 kata!'

    exports.WARNING_VOLUME_OVERFLOW = 'lebih dari amplifikasi bisa menyebabkan distorsi'

    exports.WARNING_COMMENT_TEXT_HINT = 'anda juga dapat masuk'

    exports.WARNING_COMMENT_TEXT_UNIT = 'kata'

    exports.WARING_COMMENT_NO_TEXT = 'silakan masukkan evaluasi guru'

    exports.WARING_COMMENT_NO_CONTENT = 'silakan masukkan evaluasi umum guru'

    exports.WARING_COMMENT_UPLOAD_FULL = 'tambah sampai lima gambar'

    exports.WARNING_SWITCH_CDN_SERVER
        = 'guru menukar baris akan menyebabkan semua siswa secara otomatis kembali masuk ke kelas, kau yakin untuk menukar?'

    exports.WARNING_ABROAD_CONFIRM = 'dapat.'

    exports.WARNING_ABRAOD_TIPS = 'peringatan'

    exports.WARING_PLAY_FILE_FAILED = 'gagal main berkas, tipe berkas tidak didukung atau video dibuang'

    exports.WARING_PLAY_FILE_LENGTH_FAILED = 'silakan mengunggah berkas audio / video setidaknya 1s!'

    exports.WARN_WEBRTC_MEDIA_DEVICE_PERMISSON_DENY
        = '${authType} gagal memulai, izinkan kami mendapatkan akses ke ${deviceType}'

    exports.WARN_NO_AUTH_QUIZ = 'anda telah dinonaktifkan'

    exports.WARN_NO_AUTH_ANSWER = 'anda dilumpuhkan dari izin mesin menjawab'

    exports.RISK_ASSESSMENT = 'Penghargaan risiko'

    /**
     * =================================================
     * 成功提示
     * =================================================
     */

    exports.SUCCESS_UPLOAD_DOCUMENT = 'menghantar sukses, transkode, silakan tunggu'

    exports.SUCCESS_DETECT_CAMERA = 'perangkat kamera ditemukan dengan sukses'

    exports.SUCCESS_DETECT_ASSIST_CAMERA = 'perangkat kamera bantuan ditemukan dengan sukses'

    exports.FAIL_DETECT_ASSIST_CAMERA = 'perangkat kamera bantuan tidak terdeteksi'

    /**
     * =================================================
     * 错误提示
     * =================================================
     */

    exports.ERROR_RECORD_FAIL_ON_PATH_NOT_EXIST = 'tidak ada, rekaman kursus tidak dapat terus'

    exports.ERROR_RECORD_FAIL_ON_DISK_NOT_ENOUGH = 'tidak cukup ruang disk untuk merekam kursus untuk terus'

    exports.ERROR_UPLOAD_DOCUMENT = 'upload gagal'

    exports.ERROR_DOCUMENT_TYPE_NOT_SUPPORT
        = 'galat format berkas, silakan mengunggah kata, ppt, pdf atau format gambar kursseware'

    exports.ERROR_DOCUMENT_SIZE_NOT_SUPPORT = 'silakan mengunggah berkas kurang dari 50 m'

    exports.ERROR_DOCUMENT_NAME = 'nama berkas mengandung punctuasi, silakan mengubah nama berkas dan mengunggah lagi'

    exports.ERROR_GET_GIFT_PAY_URL = 'nah, pengiriman gagal.'

    exports.ERROR_RUN_CEF_FAIL = 'inisialisasi klien gagal, silakan memulai ulang klien'

    exports.ERROR_NOT_SURPORT_SELL_TEMPLATE = 'pc tidak mendukung, silakan masukkan melalui h5'

    /**
     * =================================================
     * 邀请函
     * =================================================
     */

    exports.ENTER_CLASSROOM_BY_JOIN_CODE = 'mod kode partisipasi'

    exports.ENTER_CLASSROOM_WITH_SECRET = 'mod perintah rahasia aplikasi'

    exports.JOIN_CODE = 'kode partisipasi'

    exports.JOIN_CODE_SPECIFICATION = 'instruksi untuk menggunakan kode partisipasi'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_DAYS = 'hari '

    // 为了使倒计时的时间数字和量词之间不会挨在一起，要在‘时’和‘分’后加一个空格
    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_HOURS = 'waktu '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_MINUTES = 'cabang '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_SECONDS = 'detik'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TITLE = 'tip'

    exports.CLASS_START_TIME = 'waktu awal'

    exports.TEACH_DURATION = 'waktu mengajar'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_LABEL = 'silakan masukkan nama asli anda:'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TIP = 'masukan tidak dapat kosong'

    exports.INVITATION_TITILE_HINT = 'tip'

    exports.INVITATION_TIP_OPENING_CLIENT = 'mencoba membuka klien'

    exports.INVITATION_BUTTON_DOWNLOAD_CLIENT = 'download klien'

    exports.INVITATION_BUTTON_ENTER_CLASSROOM_VIA_WEB = 'halaman web ke ruang kelas'

    exports.INVITATION_LABEL_OTHER_METHOD_ENTER_CLASSROOM = 'cara lain untuk masuk ke kelas'

    exports.INVITATION_TIP_ADVICE_DOWNLOAD_CLIENT
        = 'jika klien tidak terpasang atau tidak dapat dibuka, silakan turunkan klien terbaru. klien dapat menonton siaran langsung lebih lancar dan lebih kuat'

    /**
     * =================================================
     * 倒计时
     * =================================================
     */

    exports.CLASSROOM_ENTER_COUNT_DOWN_TIP = 'Um.. ${preEnterTimeText} dapat memasuki ruangan sebelum memulai'

    exports.CLASS_EXPIRE_TIP = 'nah, siaran langsung sudah berakhir'

    exports.CLASS_DELETED_TIP = 'er... the live broadcast has been cancelled'

    exports.CLASSROOM_ENTER_TIP_STRING_DAYS = 'hari'

    exports.CLASSROOM_ENTER_TIP_STRING_HOURS = 'jam'

    exports.CLASSROOM_ENTER_TIP_STRING_MINUTES = 'menit'

    exports.CLASSROOM_ENTER_TIP_STRING_SECONDS = 'detik'

    exports.BUTTON_ENTER = 'masuk ke ruang langsung'

    /**
     * =================================================
     * 试听课
     * =================================================
     */
    exports.TRIAL_START_TIP
        = 'Coba dengarkan selama ${leftMinutes} menit, untuk menonton siaran langsung selengkapnya, <span class="enroll">daftar sekarang</span>'

    exports.TRIAL_END_TIP
        = 'audisi kursus akan berakhir, jadi saya merasa pidato guru itu bagus<span class="enroll">daftar sekarang</span>bar'

    exports.COURSE_ENROLL_HREF = 'daftar sekarang'

    exports.FORBIDDEN_BTN_TIP = 'only after signing up can we interact with teachers'

    exports.TRIAL_LEAVE_NOTICE = 'apakah anda yakin untuk meninggalkan kelas audisi?'

    /**
     * =================================================
     * 确认
     * =================================================
     */

    exports.CONFIRM_END_CLASS = 'kau yakin ingin meninggalkan kelas?'

    exports.CONFIRM_END_SPEAK = 'kau yakin ingin berakhir?'

    exports.CONFIRM_END_WARMING_UP = 'apakah anda yakin untuk mengakhiri pemanasan?'

    exports.CONFIRM_STOP_RECORD = 'apakah anda yakin anda ingin berhenti merekam kursus?'

    exports.CONFIRM_STOP_SCREEN_SHARE = 'anda yakin ingin berhenti berbagi desktop?'

    exports.CONFIRM_SWITCH_LINK_TYPE = 'jaringan anda tidak stabil. anda ingin menukar tipe link?'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_CLOSE_CAMERA
        = 'matikan kamera akan berhenti berbagi desktop. anda yakin ingin mematikannya?'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_OPEN_CAMERA
        = 'hidupkan kamera akan berhenti berbagi desktop. anda yakin ingin menyalakannya?'

    exports.CONFIRM_RELOAD_ON_WEBSOCKET_CLOSE_BJY = 'anda tampaknya terputus. periksa jaringan dan coba lagi?'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_SCREEN_SHARE
        = 'kamera harus diaktifkan sebelum berbagi desktop. anda ingin menyalakannya?'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_PLAY_MEDIA
        = 'untuk memainkan berkas audio dan video lokal, kamera harus diaktifkan terlebih dahulu. apakah anda ingin menyalakannya?'

    exports.CONFIRM_UPGRADE_BEFORE_USE
        = 'versi klien anda saat ini terlalu rendah untuk menerima suara dan video guru biasanya. silakan meningkatkan klien terbaru.'

    exports.CONFIRM_UPGRADE_HINT
        = 'versi klien anda saat ini terlalu rendah, silakan klik tombol update untuk mengunduh klien terbaru,<br />pengalaman fungsi yang lebih kaya'

    exports.CONFIRM_EXIT_CLASSROOM = 'Apakah harus meninggalkan Ruang Hidup?'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLASS
        = 'jika anda meninggalkan kelas dalam kelas, kelas akan secara otomatis berakhir.'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLOUD_RECORD
        = 'selama rekaman kursus, meninggalkan kelas akan secara otomatis mengakhiri kelas dan menghentikan rekaman awan'

    exports.CONFIRM_USE_CAMERA_ON_NO_AVAILABLE_CAMERA
        = 'tidak ada kamera yang tersedia ditemukan, apakah anda perlu menggunakan kamera?'

    exports.CONFIRM_USE_MIC_ON_NO_AVAILABLE_MIC
        = 'tidak terdeteksi mikrofon yang dapat digunakan. apakah anda perlu menggunakan mikrofon?'

    exports.CONFRIM_FORBID_USER_SEND_MESSAGE = 'anda yakin ingin mematikan chat ta?'

    exports.CONFIRM_REMOVE_DOCUMENT = 'anda yakin ingin menghapus saluran kursus ini?'

    exports.CONFIRM_REMOVE_HOMEWORK = 'anda yakin ingin menghapus pekerjaan?'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_CAMERA
        = 'tidak terdeteksi perangkat kamera tersedia, apakah anda ingin mendeteksi lagi?'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_ASSIST_CAMERA
        = 'tidak ada perangkat kamera bantuan yang tersedia ditemukan, apakah anda ingin mendeteksi ulang?'

    exports.CONFIRM_PURCHASE = 'kau belum mendaftar untuk kursus.'

    exports.CONFIRM_TO_TCP_LINK
        = 'menukar uplink tcp akan menyebabkan suara siswa tidak dapat direkam. apakah anda yakin untuk menukar?'

    exports.CONFIRM_END_RTMP_PUSH = 'kau yakin ingin menghentikan aliran dorongan guru?'

    exports.CONFIRM_SCREEN_SHARE_BITRATE_CHANGE
        = 'tingkat berbagi layar ruang siaran langsung telah berubah. silakan klik berbagi lagi untuk mengambil efek'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_TITLE = 'menyambung tablet'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_CONTENT
        = 'koneksi tablet gagal, silakan sambung lagi<br>silakan pastikan bahwa tablet luar terbuka dan dalam jangkauan komunikasi'

    exports.CONFIRM_BUTTON_CONNECT_HAND_WRITTING_BOARD = 'menghubung kembali'

    exports.CONFIRM_PIP_ERR
        = 'Selama inisialisasi, silakan klik "OK" untuk mengambil efek dari fungsi "menunjukkan wajah Anda"'

    exports.CONFIRM_TURN_OFF_ALL_USERS = 'apakah anda yakin ingin mematikan semua mikrofon?'

    /**
     * =================================================
     * Tooltip
     * =================================================
     */

    exports.TOOLTIP_LASER = 'pen laser'

    exports.TOOLTIP_MOVE = 'bergerak'

    exports.TOOLTIP_DOODLE = 'berus cat'

    exports.TOOLTIP_TEXT = 'kata tertulis'

    exports.TOOLTIP_ARROW = 'panah'

    exports.TOOLTIP_RECT = 'segiempat'

    exports.TOOLTIP_ERASER = 'hapus'

    exports.TOOLTIP_CLEAR = 'kosong'

    exports.TOOLTIP_SMILE = 'tersenyum'

    exports.TOOLTIP_GIGGLE = 'senyum sederhana'

    exports.TOOLTIP_PROUD = 'bangga'

    exports.TOOLTIP_NAUGHTY = 'nakal'

    exports.TOOLTIP_EXHAUSTED = 'aku sangat tidur.'

    exports.TOOLTIP_CRY = 'menangis'

    exports.TOOLTIP_EMBARRASSED = 'berputar'

    exports.TOOLTIP_DOUBT = 'keraguan'

    exports.TOOLTIP_APPEARANCE = 'warna'

    exports.TOOLTIP_POWERFUL = 'fierce'

    exports.TOOLTIP_WORSHIP = 'menyembah'

    exports.TOOLTIP_STRUGGLE = 'berjuanglah keras'

    exports.TOOLTIP_WEIGHS = 'halo'

    exports.TOOLTIP_SURPRISE = 'terkejut'

    exports.TOOLTIP_SPEECHLESS = 'tak berbicara'

    exports.TOOLTIP_HEARTSTOPPER = 'menolak'

    /**
     * =================================================
     * 对话框
     * =================================================
     */

    exports.DIALOG_MANAGE_DOCUMENT = 'pilih berkas'

    exports.DIALOG_MANAGE_HOMEWORK = 'area operasi'

    exports.DIALOG_DEBUG = 'informasi debug'

    exports.USER_DIALOG_DEBUG = 'informasi kursus'

    exports.ALERT_DEFAULT_TITLE = 'tip'

    exports.DIALOG_QUESTION_ANSWER = 'q & a'

    exports.DIALOG_DEBUG_PANEL = 'panel nyahpepijat'

    exports.DIALOG_MESSAGE_BOX_PUBLIC = 'percakapan - percakapan publik'

    exports.DIALOG_MESSAGE_BOX_RESEARCH = 'percakapan - Research'

    exports.DIALOG_MESSAGE_BOX_WHISPER = 'bicara - bicara dengan {user-name}'

    exports.DIALOG_USER_AUTH_TITLE = 'tip ramah'

    exports.MORE_BUTTON_TITLE = 'Lebih banyak ciri-ciri'

    exports.MORE_BUTTON_TITLE_EDIT = 'edit'

    exports.DIALOG_REPORT_TITLE = 'Silakan pilih alasan untuk melaporkan'

    /**
     * =================================================
     * 空文本占位符
     * =================================================
     */

    exports.PLACEHOLDER_NOTICE_FOR_WRITER = 'pengumuman kelas dapat diterbitkan di sini ~'

    exports.PLACEHOLDER_NOTICE_GROUP_FOR_WRITER = 'anda dapat mengirim notifikasi kelompok di sini ~'

    exports.PLACEHOLDER_NOTICE_FOR_READER = 'papan bulletin kosong'

    exports.PLACEHOLDER_INPUT_AMOUNT = 'silakan masukkan jumlah'

    exports.PLACEHOLDER_COMMENT_FOR_SEND = 'mari kita tulis tentang evaluasi anda dari guru'

    /**
     * =================================================
     * 一些杂七杂八的话术
     * =================================================
     */

    exports.LABEL_RECORDING = 'recording'

    exports.LABEL_WECHAT_HELP = 'bantuan wechat'

    exports.LABEL_STUDENT_JOIN_CLASS_NO = 'para siswa tidak masuk ke kelas'

    exports.LABEL_STUDENT_JOIN_CLASS_YES = 'para siswa telah masuk ke kelas'

    exports.LABEL_FAIL_AGAIN = 'masih gagal?'

    exports.LABEL_CONTACT_TEL = 'pelanggan dapat menelepon: 4000-910-910'

    exports.LABEL_CONTACT_QQ = 'atau tambah dukungan teknis qq: 3303460898'

    exports.LABEL_CLASSROOM_ID_TEXT = 'id kelas'

    exports.LABEL_TOUCH_SCREEN_SUPPERT = 'sokongan layar sentuh'

    exports.LABEL_VIDEO_POPUP_TO_AUX_SCREEN = 'video muncul ke layar bantuan'

    exports.LABEL_REPAIR_PROGRAM_SHARE = 'memperbaiki layar hitam berbagi'

    exports.LABEL_MEDIA_PANEL = 'daerah pengguna'

    exports.LABEL_MESSAGE_PANEL = 'diskusi teks'

    exports.LABEL_LOADING = 'memuatkan'

    exports.LABEL_DATA_LOADING = 'memuatkan data, tunggu'

    exports.LABEL_VIDEO = 'video'

    exports.LABEL_AUDIO = 'frekuensi audio'

    exports.LABEL_AUDIO_AND_VIDEO = 'audio dan video'

    exports.LABEL_WHITEBOARD = 'papan putih'

    exports.LABEL_CAMERA = 'kamera'

    exports.LABEL_MIC = 'mikrofon'

    exports.LABEL_MIC_AND_CAMERA = 'mikrofon dan kamera'

    exports.LABEL_SPEAKER = 'speaker'

    exports.LABEL_RECORD = 'rekam kursus'

    exports.LABEL_SHARE = 'pembahagian layar'

    exports.LABEL_CLASS_SETTING = 'kontrol kamar'

    exports.LABEL_OTHER = 'lain'

    exports.LABEL_DEVICE_LIST = 'daftar peralatan'

    exports.LABEL_AUDIO_REPAIR = 'perbaikan trek'

    exports.LABEL_AUDIO_REPAIR_NO = 'tidak perlu memperbaiki'

    exports.LABEL_AUDIO_REPAIR_LEFT = 'perbaiki saluran suara kiri'

    exports.LABEL_AUDIO_REPAIR_RIGHT = 'perbaiki saluran suara kanan'

    exports.LABEL_INPUT_VOLUME = 'volum masukan'

    exports.LABEL_OUTPUT_VOLUME = 'tingkat output'

    exports.LABEL_AGC = 'keuntungan otomatis'

    exports.LABEL_POPUP = 'mengeluarkan'

    exports.LABEL_CLOSE = 'tutup'

    exports.LAEBL_CLOSE_MIC = 'tutup'

    exports.LABEL_PRIMARY_CAMERA_SETTING = 'pengaturan kamera utama'

    exports.LABEL_MINOR_CAMERA_SETTING = 'pengaturan kamera bantuan'

    exports.LABEL_NO_AVAILABLE_CAMERA = 'tidak ada kamera tersedia'

    exports.LABEL_NO_AVAILABLE_MIC = 'tidak ada mikrofon tersedia'

    exports.LABEL_NO_AVAILABLE_SPEAKER = 'tidak ada pembicara tersedia'

    exports.LABEL_VIDEO_QUALITY = 'kualitas video'

    exports.LABEL_CAN_YOU_HEAR_YOUR_VOICE = 'tolong bicara, bisakah kau mendengar suaramu sendiri?'

    exports.LABEL_APPLY_BEFORE_SPEAK = 'tolong angkat tanganmu dulu.'

    exports.LABEL_WAIT_TEACHER_ACCEPT = 'tolong tunggu persetujuan guru'

    exports.LABEL_SPEAK_APPLYING = 'angkat tangan'

    exports.LABEL_TEACHER_SPEAK_INVITING = 'guru mengundang anda untuk berbicara tentang gandum'

    exports.LABEL_DOCUMENT_IN_LIBRARY = 'database'

    exports.LABEL_DOCUMENT_IN_USE = 'tampilkan saluran kursus'

    exports.LABEL_DOCUMENT_TYPE_HINT
        = 'untuk dokumen yang disunting wps, silakan mengubahnya menjadi pdf dan mengubahnya'

    exports.LABEL_DOCUMENT_HELP_LINK = 'klik di sini untuk melihat tutorial konversi'

    exports.LABEL_PAGE_LOADING = 'pemuatan jalur'

    exports.LABEL_DOCUMENT_TRANSFORMING = 'dokumen sedang berusaha mengubah, tunggu'

    exports.LABEL_DOCUMENT_TRANSFORMING_TIP = 'transcoding'

    exports.LABEL_DOCUMENT_TRANSFORM_COMPLETE_TIP = 'transcoding selesai'

    exports.LABEL_DOCUMENT_TRANSFORM_FAIL = 'konversisi dokumen gagal, silakan mengunggah lagi'

    exports.LABEL_CLASS_DOCUMENT = 'jalurku'

    exports.lABEL_USER_DOCUMENT = 'foto murid'

    exports.LABEL_UPLINK_BANDWIDTH = 'lebar band uplink'

    exports.LABEL_DOWNLINK_BANDWIDTH = 'lebar jalur bawah'

    exports.LABEL_FORBID_ALL_REMINDER = 'semua siswa dilarang berbicara'

    exports.LABEL_SEND_GIFT_PAY_TITLE = 'terima kasih, tn. meda.'

    exports.LABEL_LOADING_TIMEOUT = 'tidak bisa masuk ke kelas?hubungi 4000-910-910 untuk bantuan'

    exports.LABEL_SURVEY_QUESTION = 'tajuk:'

    exports.LABEL_SURVEY_MULTIPLE_ANSWER = 'pilihan berbilang'

    exports.LABEL_SURVEY_SEND_TITLE = 'membuat pertanyaan'

    exports.LABEL_SURVEY_REPLY_TITLE = 'jawaban'

    exports.LABEL_SURVEY_REPLY_RESULT = 'hasil jawaban'

    exports.LABEL_SURVEY_MYCHOICE = 'pilihan anda'

    exports.LABEL_SURVEY_RIGHT_COUNT = 'jawaban'

    exports.LABEL_SURVEY_WRONG_COUNT = 'jawaban tidak benar'

    exports.LABEL_SURVEY_OPTION_UNIT = 'orang'

    exports.LABEL_SURVEY_TITLE_NAME = 'laman jawaban'

    exports.LABEL_GIFT_TYPE_ORANGE_JUICE = 'juice orange'

    exports.LABEL_GIFT_TYPE_ICE_TEA = 'teh hitam es'

    exports.LABEL_GIFT_TYPE_BARLEY_TEA = 'teh panggang'

    exports.LABEL_RECORDING_INDICATOR = 'guru sedang merekam pelajaran'

    exports.LABEL_RECORDING_LOCAL = 'lokal'

    exports.LABEL_RECORDING_CLOUD = 'awan'

    exports.LABEL_RECORDING_PUSH = 'penangkapan dan aliran layar'

    exports.LABEL_RECORDING_SUFFIX = 'recording'

    exports.LABEL_DOC_QUALITY_HIGH = 'gambar asal'

    exports.LABEL_DOC_QUALITY_LOW = 'fluent'

    exports.LABEL_DOC_FIT_WIDTH = 'isi'

    exports.LABEL_DOC_FIT_VIEW = 'menyesuaikan'

    exports.LABEL_COMMENT_REMIND_TITLE = 'evaluasi kursus'

    exports.LABEL_COMMENT_POINT_UNIT = 'cabang'

    exports.LABEL_COMMENT_TEACHER_TITLE = 'my comments'

    exports.LABEL_COMMENT_TYPE_TOTAL = 'seluruh'

    exports.LABEL_COMMENT_TYPE_GREAT = 'puji'

    exports.LABEL_COMMENT_TYPE_MIDDLE = 'china review'

    exports.LABEL_COMMENT_TYPE_LOWER = 'komentar negatif'

    exports.LABEL_COMMENT_MAX_LENGHT = '200 kata'

    exports.LABEL_COMMENT_TOTAL_RATER = 'evaluasi umum'

    exports.LABEL_COMMENT_ANONYMOUS = 'evaluasi anonim'

    exports.LABEL_COMMENT_REMARK = 'evaluasi'

    exports.LABEL_COMMENT_POINT_FIVE = 'lima bintang'

    exports.LABEL_COMMENT_POINT_FOUR = 'empat bintang'

    exports.LABEL_COMMENT_POINT_THREE = 'samsung'

    exports.LABEL_COMMENT_POINT_TWO = 'dua bintang'

    exports.LABEL_COMMENT_POINT_ONE = 'sedikit'

    exports.LABEL_COMMENT_UNIT_TIPS = 'Total ${totalCount}'

    exports.LABEL_COMMENT_TYPE = 'evaluasi belajar'

    exports.LABEL_BEAUTIFY_AND_DENOISE = 'kecantikan dan pengurangan suara'

    exports.LABEL_SETTINGS = 'mengatur'

    exports.LABEL_AUTH_MANAGEMENT = 'manajemen otoritas'

    exports.LABEL_EYE_PROTECTION = 'eye care mode'

    exports.LABEL_SCREENSHOT = 'penangkapan layar'

    exports.LABEL_SCREENSHOT_WITH_ROOM_HIDED = 'penangkapan layar kelas tersembunyi'

    exports.LABEL_POSITION = 'Lokasi ${number}'

    exports.LABEL_DETECT_TOOL = 'deteksi sistem'

    exports.LABEL_FORBID_ALL = 'semua diam'

    exports.LABEL_SHARE_POSITION = 'tampilkan posisi gambar berbagi pada layar'

    exports.LABEL_SHARE_POSITION_MOD_TIP = 'anda dapat mengubahnya nanti dalam pengaturan'

    exports.LABEL_NUMBER_ONE = 'satu'

    exports.LABEL_NUMBER_TWO = 'two'

    exports.LABEL_NUMBER_THREE = 'tiga'

    exports.LABEL_NUMBER_FOUR = 'empat'

    exports.LABEL_NUMBER_FIVE = 'lima'

    exports.LABEL_NUMBER_SIX = 'enam'

    exports.LABEL_NUMBER_SEVEN = 'tujuh'

    exports.LABEL_NUMBER_EIGHT = 'delapan'

    exports.LABEL_NUMBER_NINE = 'sembilan'

    exports.LABEL_NUMBER_TEN = 'sepuluh'

    exports.LABEL_SERVER_ROUTE = 'Baris ${angka}'

    exports.LABEL_OTHER_SERVER_ROUTE = 'garis lain'

    exports.LABEL_CDN_ROUTE_PRIMARY = 'utama'

    exports.LABEL_CDN_ROUTE_ASSISTANT = 'wakil...'

    exports.LABEL_CHECK_ALL = 'pilih semua'

    exports.LABEL_UNIT = 'individu'

    exports.LABEL_LINK_TYPE = 'jenis pautan'

    exports.LABEL_UPLINK = 'upstream'

    exports.LABEL_DOWNLINK = 'turun'

    exports.LABEL_tcp = 'tcp'

    exports.LABEL_udp = 'udp'

    exports.LABEL_TEACHER = 'teacher'

    exports.LABEL_NICKNAME = 'nama panggilan?'

    exports.LABEL_DON_NOT_REMIND_ANY_MORE = 'jangan mengingatkanku lagi lain kali'

    exports.LABEL_GIFT_PAY_HINT = 'metode pembayaran'

    exports.LABEL_GIFT_WECHAT = 'wechat'

    exports.LABEL_GIFT_ALIPAY = 'alipay'

    exports.LABEL_COMMENT_RECEIVE_TITLE = 'daftar evaluasi'

    exports.LABEL_COMMENT_SEND_TITLE = 'evaluasi kursus'

    exports.LABEL_LOTTERY_SEND_TITLE = 'hadiah'

    exports.LABEL_LOTTERY_SEND_HEADER = '"katakan pada siswa, apa kejutan kali ini"'

    exports.LABEL_LOTTERY_SEND_NAME = 'nama hadiah'

    exports.LABEL_LOTTERY_SEND_NUMBER = 'jumlah hadiah'

    exports.LABEL_CURRENT_STUDENT_COUNT = 'Siswa kelas saat ini ${userCount} orang'

    exports.LABEL_LOTTERY_SEND_HINT
        = 'jika anda memenangkan hadiah, anda dapat mendapatkan kode hadiah<br/>silakan hubungi siswa untuk pertukaran hadiah'

    exports.LABEL_LOTTERY_DRAW_HINT = 'guru akan memberikan hadiah dengan kode'

    exports.LABEL_LOTTERY_SEND_BTN = 'kirim hadiah'

    exports.LABEL_LOTTERY_UNIT = 'berbagi'

    exports.LABEL_LOTTERY_REMAIN = 'apa yang tersisa'

    exports.LABEL_LOTTERY_SAVE_LIST = 'simpan daftar'

    exports.LABEL_LOTTERY_DRAW_TIP = 'aku mengirim hadiah'

    exports.LANEL_LOTTERY_DRAW_BTN = 'buang amplop merah'

    exports.LABEL_LOTTERY_DRAW_SUCC = 'selamat!anda memenangkan hadiah'

    exports.LABEL_LOTTERY_DRAW_CODE = 'kode hadiah'

    exports.LABEL_LOTTERY_SHOW_WINNERS = 'lihatlah keberuntunganmu.'

    exports.LABEL_LOTTERY_DRAW_FAIL = 'slow down, the red envelope is over'

    exports.LABEL_LOTTERY_REDPACK = 'ampulop merah'

    exports.LABEL_OF_UNITE = 'dari'

    exports.LABEL_INPUT_LOTTERY_NAME = 'silakan masukkan nama hadiah'

    exports.LABEL_INPUT_LOTTERY_NUMBER_ERROR = 'silakan masukkan jumlah hadiah yang tepat'

    exports.LABEL_INPUT_LOTTERY_OVER_MEMBER = 'jumlah hadiah tidak dapat lebih besar dari jumlah siswa'

    exports.LABEL_INPUT_LOTTERY_OVER_MAX = 'jumlah hadiah seharusnya tidak lebih dari 50'

    exports.LABEL_CAMERA_PIXEL_RATIO = 'nisbah video'

    exports.LABEL_CAMERA_SETTING = 'pengaturan video'

    exports.LABEL_CAMERA_FLIP_HORIZONTAL = 'balik secara horisontal'

    exports.LABEL_CAMERA_FLIP_VERTICAL = 'flip vertikal'

    exports.LABEL_CAMERA_CROP = 'potong layar'

    exports.LABEL_CAMERA_DISENABLE = 'jangan aktifkan'

    exports.LABEL_TIP_CLICK_BTN_START_CLASS = 'klik tombol untuk memulai kelas'

    exports.LABEL_UPDATE_OLD_CLIENT_VERSION
        = 'versi klien saat ini terlalu rendah, silakan meningkatkan ke versi terbaru'

    exports.LABEL_UPDATE_CLIENT_VERSION = 'pergi untuk mengunduh klien terbaru'

    exports.LABEL_CLOSE_CLIENT = 'tutup klien'

    exports.LABEL_CLIENT_INVITE_CODE = 'kode undangan klien'

    exports.LABEL_WEB_LINK = 'hubungan web'

    exports.LABEL_REFRESH_WAITED = 'memrefresh, silakan tunggu'

    exports.LABEL_SHAREING_NO_OPTION = 'operasi ini tidak didukung dalam pembagian layar'

    exports.LABEL_WHISPER_TITLE = 'percakapan pribadi'

    exports.LABEL_BARRAGE = 'Barrage'

    exports.LABEL_LOCK_SCREEN = 'Kunci mahasiswa'

    exports.LABEL_RAISE_HAND = 'raise hands'

    exports.LABEL_APPLY_SPEAK = 'Permintaan untuk berbicara'

    exports.LABEL_SAVE_SUCCESS = 'Disimpan dengan sukses！'

    /**
     * =================================================
     * 求助
     * =================================================
     */

    exports.BUTTON_CUSTOM_SERVICE_QQ = 'bantuan qq'

    exports.BUTTON_CUSTOM_SERVICE_TECHNICAL = 'bantuan teknis'

    exports.BUTTON_CUSTOM_SERVICE_CLASS_INFO = 'informasi kursus'

    exports.DIALOG_TITLE_TECH_HELP = 'bantuan teknis'

    exports.BUTTON_CUSTOM_SERVICE_WECHAT = 'bantuan wechat'

    exports.BUTTON_CUSTOM_SERVICE_OFFICIAL = 'website resmi untuk bantuan'

    exports.TITLE_HELP_TYPE = 'jenis bantuan mencari'

    exports.TITLE_CONTACT_WAY = 'contact information'

    exports.TYPE_VIDEO_LAG = 'audio dan video caton'

    exports.TYPE_CLIENT_CRASH = 'kecelakaan sistem'

    exports.TYPE_OTHER = 'lain'

    exports.CONTACT_TYPE_qq = 'qq'

    exports.CONTACT_TYPE_PHONE = 'telepon'

    exports.PLACEHOLDER_DESCRIPTION = 'silakan masukkan deskripsi bantuan anda'

    exports.INFO_CREATE_HELP_SUCCESS
        = 'bantuan teknis telah dikirim kepada guru-guru yang relevan, kami akan menghubungimu nanti!'

    exports.UNKNOW_ERROR = 'kesalahan tidak diketahui terjadi'

    exports.WARING_INVALID_PHONE = 'nomor ponsel tidak valid'

    exports.WARING_INVALID_QQ = 'nomor qq tidak valid'

    exports.WARING_DESCRIPTION_EMPTY = 'informasi deskripsi tidak dapat kosong'

    exports.SUBMIT_HELP_TOO_FREQUENT = 'tolong jangan mengirim bantuan terlalu sering ~'

    /**
     * =================================================
     * 音视频播放器相关话术
     * =================================================
     */

    exports.MEDIA_PLAYER_KEEP_ON = 'silakan tetap alat av menyala'

    exports.MEDIA_PLAYER_FILE_LOADING = 'Memuat ${fileName}'

    exports.MEDIA_PLAYER_CLOSE_VIDEO = 'kamera telah diaktifkan. klik untuk menutup gambar'

    exports.MEDIA_PLAYER_OPEN_VIDEO = 'kamera telah diaktifkan, klik untuk membuka gambar dari pihak lain'

    exports.MEIDA_PLAYER_CAMERA_OFF = 'sisi lain tidak menyalakan kamera'

    exports.MEDIA_PLAYER_MIC_ON = 'mikrofon menyala'

    exports.MEDIA_PLAYER_MIC_OFF = 'mikrofon tidak menyala'

    exports.MEDIA_PLAYER_CLOSE_MIC = 'klik untuk menutup mikrofon'

    exports.MEDIA_PLAYER_POPUP = 'klik jendela pop-up'

    exports.MEDIA_PLAYER_SWITCH = 'klik untuk menukar jendela ppt dan video'

    exports.MEDIA_PLAYER_VIDEO_DOWNLINK_BANDWIDTH = 'terima video:'

    exports.MEDIA_PLAYER_AUDIO_DOWNLINK_BANDWIDTH = 'terima audio:'

    exports.MEDIA_PLAYER_VIDEO_UPLINK_BANDWIDTH = 'memuat naik video:'

    exports.MEDIA_PLAYER_AUDIO_UPLINK_BANDWIDTH = 'menguasai audio:'

    exports.MEDIA_PLAYER_FOLD = 'letakkan itu pergi'

    exports.MEDIA_PLAYER_UNFOLD = 'buka'

    /**
     * =================================================
     * CEF 相关话术
     * =================================================
     */

    exports.CEF_ERROR_PLAYBACK_AUDIO = 'ada sesuatu yang salah dengan perangkat audio'

    exports.CEF_ERROR_SYSTEM_NOT_SUPPORT
        = 'sistem operasi anda tidak mendukung fungsi ini. silakan ganti komputer anda atau meningkatkan sistem operasi anda'

    exports.CEF_ERROR_CAMERA_IS_BUSY = 'kamera anda mungkin sibuk dengan aplikasi lain, silakan periksa'

    exports.CEF_ERROR_OPEN_MIC = 'gagal membuka mikrofon. silakan memulai ulang klien'

    exports.ALERT_CREATE_STREAM_TIMEOUT = 'Timeout untuk mendapatkan aliran audio dan video.silakan periksa perangkat kamera dan segar-segar dan coba lagi.'

    exports.CEF_ERROR_WORK_MIC = 'mikrofon tidak bekerja dengan benar, silakan periksa'

    exports.CEF_ERROR_OPEN_SPEAKER = 'gagal menyalakan speaker, silakan memulai ulang klien'

    exports.CEF_ERROR_CAPTURE_AUDIO = 'mikrofon gagal mengumpulkan data, silakan memulai ulang klien'

    /**
     * =================================================
     * 需要变量替换的一些话术
     * =================================================
     */

    exports.TPL_LOGIN_CONFLICT = 'Kode akun/partisipasi Anda masuk di ${endType}, harap konfirmasi dan masuk lagi!'

    exports.TPL_STUDENT_SEND_TEACHER_GIFT = 'Terima hadiah dari <em>${userName}</em>'

    exports.TPL_TEACHER_RECEIVE_STUDENT_GIFT = '<em>${userName}</em> dilarang oleh guru'

    exports.TPL_TEACHER_FORBID_USER_SEND_MESSAGE = '<em>${userName}</em>dilarang oleh guru'

    exports.TPL_CUSTOM_SERVICE_CALL
        = 'Klik untuk mengonfirmasi dan menghubungi staf dukungan teknis<br />Harap angkat panggilan di ponsel Anda <em> ${mobile} </em>'

    exports.TPL_DETECT_TOOL_NET_STATUS_SPEED = '<em>${netStatusMsg}</em>, tunda ${speed}ms'

    exports.TIME_NOCTICE_JOIN_CLASS = 'Akan masuk kembali ke kelas setelah ${seconds}s'

    /**
     * =================================================
     * 登录注册
     * =================================================
     */

    exports.LOGIN_REGISTER_LOGIN = 'daftar masuk'

    exports.LOGIN_REGISTER_REGISTER = 'register'

    exports.LOGIN_REGISTER_LOGIN_WAITING = 'logging in'

    exports.LOGIN_REGISTER_REGISTER_WAITING = 'mendaftar'

    exports.LOGIN_REGISTER_MOBILE = 'silakan masukkan nomor ponsel'

    exports.LOGIN_REGISTER_SET_PASSWORD = 'silakan tetapkan sandi'

    exports.LOGIN_REGISTER_INPUT_PASSWORD = 'silakan masukkan sandi'

    exports.LOGIN_REGISTER_INPUT_VERIFYCODE = 'silakan masukkan kode verifikasi ponsel'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE = 'dapatkan kode verifikasi'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE_COUNTING = 'coba lagi dalam detik'

    exports.LOGIN_REGISTER_MOBILE_ERROR = 'silakan masukkan nomor ponsel yang tepat'

    exports.LOGIN_REGISTER_PASSWORD_ERROR = 'silakan masukkan kata sandi yang benar'

    exports.LOGIN_REGISTER_CAPTCHA_ERROR = 'silakan masukkan kode verifikasi grafik yang benar'

    exports.LOGIN_REGISTER_VERIFYCODE_ERROR = 'silakan masukkan kode verifikasi yang benar'

    exports.LOGIN_REGISTER_DIALOG_TITLE = 'konfirmasi daftar masuk'

    exports.LOGIN_REGISTER_LOGIN_BY_SMS = 'login sms'

    exports.LOGIN_REGISTER_LOGIN_BY_PASSWORD = 'login kata sandi'

    exports.LOGIN_REGISTER_INPUT_CAPTCHA = 'silakan masukkan teks di bawah'

    exports.LOGIN_REGISTER_SWITCH_ROLE = 'Kau tidak punya identitas murid, kau ingin membuka identitas murid?'

    /**
     * =================================================
     * 紧急呼叫（客服电话拨打）
     * =================================================
     */

    exports.CUSTOM_SERVICE_NEED_CALL = 'ada masalah?panggilan gratis untuk bantuan!'

    exports.CUSTOM_SERVICE_CONFIRM_CALL = 'konfirmasi panggilan'

    exports.CUSTOM_SERVICE_REJECT_CALL = 'tidak ada ponsel'

    exports.CUSTOM_SERVICE_EXTRA_FEE
        = '(beberapa pengguna mungkin ditugaskan oleh operator untuk menjawab atau roaming karena paket ponsel)'

    exports.CUSTOM_SERVICE_CALLING = 'telepon bantuan memanggil'

    exports.CUSTOM_SERVICE_PICKUP
        = 'silakan sambung<em>010-86448910</em>panggilan anda<br />dan tunggu personil dukungan teknis untuk melayani anda'

    exports.CUSTOM_SERVICE_DAIL = 'panggilan langsung untuk bantuan'

    exports.CUSTOM_SERVICE_DAIL_CONTENT
        = 'anda dapat menghubungi staf dukungan teknis sendiri<br />dan tunggu personil dukungan teknis untuk melayani anda<br /><em>four billion nine hundred and ten thousand nine hundred and ten</em>'

    exports.CUSTOM_SERVICE_AUTO_CLOSE = 'jendela menutup secara otomatis'

    exports.CUSTOM_SERVICE_DIALOG_TITLE = 'bantu layanan pelanggan'

    exports.CUSTOM_SERVICE_QQ_MESSAGE = 'pilih dukungan teknik untuk memecahkan masalah dalam waktu nyata melalui qq'

    exports.CUSTOM_SERVICE_QQ_SYSTEM_INFO = 'Sistem: {system}, nomor versi: {system-version}'

    exports.CUSTOM_SERVICE_QQ_BROWSER_INFO = 'Terminal: {browser}, nomor versi: {browser-version}'

    exports.CUSTOM_SERVICE_QQ_PRIMARY = 'technical support 1'

    exports.CUSTOM_SERVICE_QQ_SECONDARY = 'dukungan teknis 2'

    /**
     * =================================================
     * 设备变更
     * =================================================
     */

    exports.DEVICE_CHANGE_ADD_AUDIO = 'mikrofon saat ini telah ditukar ke perangkat yang baru dimasukkan'

    exports.DEVICE_CHANGE_ADD_VIDEO = 'kamera saat ini telah ditukar ke perangkat yang baru dimasukkan'

    exports.DEVICE_CHANGE_DEL_AUDIO = 'perangkat mikrofon dihapuskan, ditukar ke perangkat lalai'

    exports.DEVICE_CHANGE_DEL_VIDEO = 'perangkat kamera dihapuskan, ditukar ke perangkat lalai'

    exports.DEVICE_CHANGE_RESET = 'setup cepat'

    /**
     * =================================================
     * 签到
     * =================================================
     */

    exports.SIGNIN_TITLE_HINT = 'panggilan roll'

    exports.SIGNIN_START = 'nama awal'

    exports.SIGNIN_STATUS = 'apa situasinya?'

    exports.SIGNIN_TIME_NOTICE = 'Harap setel siswa untuk merespons dalam ${detik}'

    exports.SIGNIN_ACK_COUNT = '${member} orang menjawab'

    exports.SIGNIN_NACK_COUNT = '${member} orang yang belum dijawab'

    exports.SIGNIN_EXPECT_COUNT = 'Harus menjangkau ${member} orang'

    exports.SIGNIN_LIST_DOWNLOAD = 'download daftar penuh'

    exports.GROUP_SIGNIN_LIST_DOWNLOAD = 'muat turun daftar kelompok ini'

    exports.SIGNIN_NO_LIST = 'daftar orang yang tidak dijawab'

    exports.SINGIN_NO_NOTICE
        = 'sistem menunjukkan 50 orang yang belum menjawab daftar. untuk daftar lengkap, silakan klik'

    exports.SIGNIN_AGAIN = 'putar panggilan lagi'

    exports.SIGNIN_AGAIN_TIME_NOTICE = 'Roll call dapat dimulai lagi dalam ${seconds} detik'

    exports.SINGIN_WAIT_TIME_NOTICE
        = 'Siswa menjawab satu demi satu, hasilnya dapat dilihat dalam ${detik} detik, harap tunggu'

    exports.SIGNIN_REPLAY = 'jawabannya adalah ya'

    exports.SIGNIN_REPLAY_TIME_NOTICE = 'Guru meminta Anda untuk menanggapi panggilan masuk dalam ${detik} detik'

    exports.SIGNIN_RESULT_GETTING = 'statistik hasil panggilan gulung'

    exports.SIGNIN_COMPLETE_NOTICE = 'statistik panggilan gulungan selesai'

    exports.SIGNIN_GETTING_RESULT = 'lihat hasil'

    /**
     * =================================================
     * 到课名单
     * =================================================
     */

    exports.JOIN_USERLIST_TITLE_HINT = 'tip'

    exports.JOIN_USERLIST_TITLE_LIST = 'daftar peserta'

    exports.JOIN_USERLIST_HINT
        = 'daftar kedatangan akan merekam gelaran, waktu kedatangan paling awal dan waktu lepas dari siswa yang mendaftar untuk kelasmu.<br />para mahasiswa yang menghabiskan waktu khusus pendek di kelas tidak termasuk dalam daftar.<br />proses pembuatan daftar mungkin menyebabkan terjebak,<em>it is recommended to use this function after class</em>.'

    exports.JOIN_USERLIST_COPY_HINT = 'digenerasikan ke daftar kelas.you can export to a csv file'

    exports.LABEL_CONFIRM = 'konfirmasi'

    exports.JOIN_USERLIST_CLOSE = 'tutup'

    exports.JOIN_USERLIST_FETCH = 'hasilkan daftar'

    exports.JOIN_USERLIST_FETCHING = 'bangunan'

    exports.JOIN_USERLIST_STUDENT_ID = 'id siswa'

    exports.JOIN_USERLIST_STUDENT_NAME = 'nama panggilan murid'

    exports.JOIN_USERLIST_LOGIN_TIME = 'waktu masukan awal'

    exports.JOIN_USERLIST_LOGOUT_TIME = 'waktu berangkat terakhir'

    exports.JOIN_USERLIST_GROUP = 'id kelompok'

    exports.JOIN_USERLIST_ENDTYPE = 'jenis terminal'

    exports.JOIN_USERLIST_COPY = 'eksport'

    exports.JOIN_USERLIST_STILL_IN = 'tidak pergi'

    exports.JOIN_USERLIST_NOBODY_HINT = 'tidak ada siswa di kelas untuk saat ini'

    /**
     * =================================================
     * 助教链接
     * =================================================
     */

    exports.ASSISTANT_LINK = 'links to teaching assistants'

    exports.ASSISTANT_LINK_NEW_HINT
        = '[latest update] teaching assistants can use<em>klien</em>daftar masuk kelas & rekaman & play video_;entri: halaman login klien (sudut kanan bawah)'

    exports.ASSISTANT_LINK_HINT
        = 'salin dan kirim link asisten mengajar ke rekan kecil. dia bisa menjadi asisten mengajar dan masuk ke kelas langsung.<br />dan memiliki siswa manajemen untuk berbicara, melarang siswa untuk berbicara, membantu untuk merekam kelas dan sebagainya pada banyak pihak berwenang.'

    exports.ASSISTANT_LINK_LABEL_NAME = 'nama asisten mengajar:'

    exports.ASSISTANT_LINK_LABEL_AVATAR = 'pilih avatar anda:'

    exports.ASSISTANT_LINK_DEFAULT_NAME = 'asisten'

    exports.ASSISTANT_LINK_NAME_MAXLENGTH = 'nama tidak lebih dari 8 kata'

    exports.ASSISTANT_LINK_NAME_EMPTY = 'silakan masukkan nama asisten pengajar'

    exports.ASSISTANT_LINK_SUCCESS = 'hubungan asisten mengajar dibuat dengan sukses, tolong simpan rahasia!'

    exports.ASSISTANT_LINK_COPY_SUCCESS = 'salin link berhasil'

    exports.ASSISTANT_LINK_FAILURE = 'hubungan salah ta'

    /**
     * =================================================
     * 课件缩放工具条
     * =================================================
     */

    exports.DOC_QUALITY_LOW = 'fluency: penggunaan kursus kompresi, putar halaman lebih cepat.'

    exports.DOC_QUALITY_HIGH = 'gambar asli: kursusnya jelas, tapi<em>mudah untuk terjebak</em>.'

    exports.DOC_FIT_VIEW = 'menyesuaikan'

    exports.DOC_FIT_WIDTH = 'isi'

    exports.ALLOW_STUDENT_CHANGE_PPT = 'izinkan: izinkan siswa untuk memutar halaman.'

    exports.FORBID_STUDENT_CHANGE_PPT = 'melarangkan: melarang para siswa untuk mengubah halaman.'

    exports.HIDDEN_REMARKINFO = 'sembunyi: tidak menampilkan teks catatan dalaman ppt.'

    exports.SHOW_REMARKINFO = 'tampilkan: tampilkan teks catatan dalaman ppt.'

    /**
     * =================================================
     * 系统检测工具
     * =================================================
     */

    exports.DETECT_TOOL_DIALOG_TITLE = 'deteksi sistem'

    exports.DETECT_TOOL_CUSTOM_SERVICE = 'minta dukungan teknis'

    exports.DETECT_TOOL_TIPS = 'suaran untuk solusi:'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_GOOD = 'excellent - smooth class'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_OK = 'jenderal - kadang-kadang caton'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_NORMAL = 'kasihan - sering terjebak'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_BAD = 'ini buruk - tidak ada kelas'

    exports.DETECT_TOOL_NET_STATUS_GOOD = 'jaringan yang luar biasa'

    exports.DETECT_TOOL_NET_STATUS_OK = 'jaringan umum'

    exports.DETECT_TOOL_NET_STATUS_POOR = 'jaringan yang buruk'

    exports.DETECT_TOOL_NET_STATUS_TERRIBLE = 'internet buruk'

    exports.DETECT_TOOL_NET_STATUS_DETECT = 'deteksi koneksi jaringan'

    exports.DETECT_TOOL_NET_STATUS_DETECTING = 'deteksi jaringan'

    exports.DETECT_TOOL_NET_STATUS_TIPS_HEADER = 'jika jaringan tidak baik, silakan coba metode berikut:'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CLOSE_P2P
        = 'matikan petir dan perangkat lunak p2p lainnya, dan gunakan kabel jaringan untuk menghubungkan komputer'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CHECK_LAN
        = 'periksa apakah ada pengguna lain yang mempekerjakan jumlah besar lebar band di lan'

    exports.DETECT_TOOL_NET_STATUS_TIPS_REBOOT = 'mulai ulang komputer dan router anda'

    exports.DETECT_TOOL_NET_STATUS_NO_RESULT
        = 'tidak ada informasi pengukuran kecepatan atau jaringan terputus, silakan tes ulang'

    exports.DETECT_TOOL_HELP_NET = 'faq jaringan'

    exports.DETECT_REFRESH_NOTICE
        = 'tak bisa berhubungan dengan kelas?anda dapat menukar jaringan dan mencoba untuk menyegarkan ~'

    exports.DETECT_NET_PROGRAM_REFRESH_NOTICE = 'menyambung kembali, tolong tunggu'

    exports.DETECT_TOOL_REDETECT = 'uji ulang'

    exports.DETECT_TOOL_SPEAKER_DETECT = 'deteksi pembicara'

    exports.DETECT_TOOL_SPEAKER_INITIATING = 'inisialisasi pembicara'

    exports.DETECT_TOOL_SPEAKER_TEST_SOUND_PLAYING = 'uji musik bermain'

    exports.DETECT_TOOL_SPEAKER_HAVE_YOU_HEARD = 'bisakah kau mendengar suara tes?'

    exports.DETECT_TOOL_SPEAKER_NO_DEVICE = 'tidak terdeteksi perangkat pembicara'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHECK_PLUG = 'periksa apakah koneksi speaker normal dan menyala'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_DEVICE = 'tukar perangkat speaker'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME = 'laras volum speaker'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME_OUTER = 'laras tombol volume speaker luar'

    exports.DETECT_TOOL_SPEAKER_TIPS_OS_SETTING
        = 'open<span class="os-setting-trigger">setup tombol</span>untuk melihat apakah pembicara dilumpuhkan'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_MAC
        = 'open<em>preferensi sistem > sound > output</em>, tampil pengaturan speaker'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_WINDOWS
        = 'open<em>mulai > panel kontrol > suara > main</em>untuk melihat apakah pembicara dilumpuhkan'

    exports.DETECT_TOOL_HELP_SPEAKER = 'faq pembicara'

    exports.DETECT_TOOL_MIC_DETECT = 'microphone detection'

    exports.DETECT_TOOL_MIC_DETECTING = 'silakan bicara ke mikrofon'

    exports.DETECT_TOOL_MIC_DETECTING_TIPS
        = 'ketika berbicara, disarankan memakai headphones dan mematikan speaker untuk menghindari echo'

    exports.DETECT_TOOL_MIC_HAS_INPUT = 'input suara ditemukan dengan sukses'

    exports.DETECT_TOOL_MIC_HAS_INPUT_WARNING
        = 'sangat direkomendasikan untuk mematikan pembicara luar dan memakai headphones untuk menghindari bersiul dan eco'

    exports.DETECT_TOOL_MIC_NO_INPUT = 'tidak terdeteksi input suara'

    exports.DETECT_TOOL_MIC_NO_DEVICE = 'tidak terdeteksi perangkat mikrofon'

    exports.DETECT_TOOL_MIC_TIPS_HEADER = 'jika anda memiliki pertanyaan, silakan coba metode berikut:'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_VOLUME = 'laras volum mikrofon'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_DEVICE = 'tukar perangkat mikrofon'

    exports.DETECT_TOOL_MIC_TIPS_HEADER_UNDETECTED = 'coba berikutnya:'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_PLUG = 'periksa apakah koneksi mikrofon normal dan menyala'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_BLOCK
        = 'periksa apakah perangkat lunak pelayar dan manajer komputer memblokir penggunaan perangkat'

    exports.DETECT_TOOL_MIC_TIPS_OS_SETTING
        = 'open<span class="os-setting-trigger">pengaturan mikrofon</span>untuk melihat apakah mikrofon dinonaktifkan'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_MAC
        = 'open<em>preferensi sistem > suara > input</em>, melihat pengaturan mikrofon'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_WINDOWS
        = 'open<em>mulai > panel kontrol > suara > rekor</em>untuk melihat apakah mikrofon dinonaktifkan'

    exports.DETECT_TOOL_HELP_MIC = 'microphone faq'

    exports.DETECT_TOOL_CAMERA_DETECT = 'deteksi kamera'

    exports.DETECT_TOOL_CAMERA_HAS_CAMERA = 'bisakah kau lihat gambarnya?'

    exports.DETECT_TOOL_CAMERA_NO_CAMERA = 'tidak terdeteksi perangkat kamera'

    exports.DETECT_TOOL_CAMERA_TIPS_HEADER = 'jika anda tidak melihat gambar, cobalah berikut:'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_PLUG = 'periksa apakah kamera terhubung dengan benar'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_CLOSE_OTHER
        = 'silakan mencoba menutup program lain yang mungkin mengumpulkan kamera'

    exports.DETECT_TOOL_CAMERA_TIPS_CHANGE_DEVICE = 'menukar perangkat kamera'

    exports.DETECT_TOOL_CAMERA_TIPS_OS_SETTING = 'pengaturan kamera'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_MAC
        = 'tetap<em>apple > about this machine > preview > system report > camera / usb</em>periksa apakah perangkat kamera dipasang secara biasa di'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_WINDOWS
        = 'tetap<em>mulai > panel kontrol > manajer peranti</em>periksa apakah perangkat kamera dipasang secara biasa di'

    exports.DETECT_TOOL_HELP_CAMERA = 'faq kamera'

    exports.DETECT_TOOL_FINISH = 'tes sistem selesai'

    exports.DETECT_TOOL_FINISH_TIPS
        = 'jika sistem masih memiliki masalah, silakan coba memulai ulang klien, komputer dan router, atau kontak dukungan teknis untuk bantuan'

    /**
     * =================================================
     * settings
     * =================================================
     */

    exports.SETTINGS_MIC_PREFERENCE_SCALING = 'mic boost'

    exports.SETTINGS_MIC_PREFERENCE_SCALING_UNIT = 'db'

    exports.SETTINGS_TIP_DETECT_CLOSE = 'Perangkat pendeteksi akan menutup ${services}, apakah Anda ingin melanjutkan?'

    exports.SETTINGS_INFO_TIP_OPEN_CAMERA = 'untuk pelajaran video, silakan klik untuk membuka kamera'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_CAMERA_FORBIDDEN
        = 'kurs adalah kursus langsung audio, dan kamera tidak diizinkan'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_SCREEN_SHARE_FORBIDDEN
        = 'kurs adalah kursus langsung audio, dan fungsi berbagi layar tidak diizinkan'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_MEDIA_PLAY_FOBIDDEN
        = 'kurs adalah kursus langsung audio, dan berkas video tidak dapat dimainkan'

    /**
     * =================================================
     * 媒体服务器切换后的相关提示
     * =================================================
     */

    exports.SWITCH_TIP_CLOSE_CAMERA
        = 'dideteksi bahwa jaringan anda bergerak besar dan kehilangan paket serius. anda dapat mencoba mematikan video untuk mempermudahkan gigi stu'

    exports.SWITCH_TIP_SWITCH_CDN
        = 'dideteksi bahwa jaringan anda bergerak besar dan kehilangan paket serius. anda dapat mencoba untuk menukar garis untuk mengurangi jamnya'

    exports.SWITCH_TIP_QUALITY
        = 'dideteksi bahwa jaringan anda bergerak besar dan kehilangan paket serius. silakan mengurangi definisi untuk memudahkan stodents stu'

    exports.SWITCH_TIP_NET_STATUS
        = 'dideteksi bahwa jaringan anda bergerak besar dan kehilangan paket serius. silakan periksa kondisi jaringan'

    exports.SWITCH_TIP_TEACHER_NET_STATUS
        = 'jaringan sisi guru sangat berbeda, dan kadang-kadang akan ada fenomena terjebak'

    /**
     * =================================================
     * 底部操作 class ation 相关
     * =================================================
     */
    exports.CLASS_ACTION_TIP_DOWNLOAD_WINDOWS
        = 'hanya klien yang bisa mengangkat tangannya,'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=windows" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD_MAC
        = 'hanya klien yang bisa mengangkat tangannya,'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=mac" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD
        = 'hanya klien yang bisa mengangkat tangannya,'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载'

    /**
     * =================================================
     * 进入教室过程中的提示
     * =================================================
     */

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECTING = 'menyambung ke server utama'

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECT_SUCCESS = 'server utama terhubung dengan sukses'

    exports.ENTER_CLASSROOM_SERVER_INFO_FETCH_SUCCESS = 'informasi server berhasil diperoleh'

    exports.ENTER_CLASSROOM_ROOM_SERVER_CONNECT_SUCCESS = 'server ruang kelas terhubung dengan sukses'

    exports.ENTER_CLASSROOM_ROOM_SERVER_LOGIN_SUCCESS = 'login server ruang kelas berhasil'

    exports.ENTER_CLASSROOM_AUTH_TOKEN_FAIL = 'pengguna ilegal'

    exports.ENTER_CLASSROOM_OVERMAN = 'ruangannya penuh. silakan coba lagi nanti'

    exports.ROOM_SERVER_LOGIN_CONFLICT_CONFIRM
        = 'sudah ada guru di ruang kelas. masuk akan menyebabkan guru keluar dari ruang kelas. apakah anda ingin terus masuk?'

    /**
     * =================================================
     * 新手引导相关话术
     * =================================================
     */

    exports.USER_GUIDE_DOWNLOAD_TEACHER
        = 'menggunakan klien untuk mengajar, audio dan video lebih mudah, dan fungsi mengajar lebih banyak. semua siswa menggunakannya,'
        + '你还等什么？快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    exports.USER_GUIDE_DOWNLOAD_STUDENT
        = 'menggunakan klien untuk mendengarkan audio dan video lebih mudah. anak-anak menggunakannya. apa yang kau tunggu?'
        + '快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    /**
     * =================================================
     * 服务器重连提示
     * =================================================
     */

    exports.RECONNECT_ROOM_SERVER_WAITING = 'jaringan tidak kuat, silakan periksa jaringan'

    exports.RECONNECT_ROOM_SERVER_SUB_WAITING = 'mencoba menghubungkan kembali'

    exports.ROOM_SERVER_LOGIN_EXPIRED_TIP = 'the classroom has expired'

    /**
     * =================================================
     * 录制课程
     * =================================================
     */

    exports.RECORD_CLASS_REMIND = 'pencatatan terganggu, tolong klik rekaman lagi'

    exports.RECORD_INFO_TIP = 'disarankan untuk memulai rekaman kelas dan mengunggah playback setelah kelas'

    exports.RECORD_COMPLETE_TIP = 'rekaman kursus selesai,<span class="btn-action">buka berkas rekor kelas lokal</span>'

    exports.RECORD_STOPPING_TIP = 'sedang menghasilkan file rekaman lokal, mohon tunggu...'

    exports.RECORD_RESTART_TIP
        = 'rekaman lokal berhenti. silakan coba lagi<span class="btn-action">buka</span>rekaman lokal'

    /**
     * =================================================
     * 自动录课
     * =================================================
     */

    exports.AUTO_RECORD_START = 'pencatatan kursus akan dimulai secara otomatis'

    exports.AUTO_RECORD_RESTART = 'rekaman kursus akan dibuka kembali'

    exports.AUTO_RECORD_STOP = 'rekaman kursus dihentikan dan dapat diunggah ke siswa dalam klien untuk penelitian'

    exports.AUTO_RECORD_CLASS_COUNT_DOWN_TIP = 'buka secara otomatis dalam detik'
    exports.AUTO_RECORD_CANCEL = 'batalkan rekaman'
    exports.AUTO_RECORD_LATER = 'ingatkan nanti'

    exports.AUTO_RECORD_MODE_CLOUD_AND_LOCAL = 'awan + lokal'

    exports.AUTO_RECORD_MODE_CLOUD = 'awan'

    exports.AUTO_RECORD_MODE_LOCAL = 'lokal'

    exports.AUTO_RECORD_REASON = 'pelajaran ini ditetapkan untuk menyediakan playback pada awal pelajaran'

    exports.AUTO_RECORD_TIP_NET_DISK_EMPTY
        = 'ruang penyimpanan data penuh, tidak dapat merekam di awan. silakan mulai merekam secara manual setelah kapasitas ekspansi'

    exports.NO_RECORD_WHEN_AUTO_RECORD
        = 'sistem mendeteksi bahwa rekaman awan tidak diaktifkan. anda ingin mengaktifkan rekaman awan'

    /**
     * =================================================
     * 环境监测
     * =================================================
     */

    exports.ENV_DETECT_HEADER = 'akcelerasi jaringan'

    exports.ENV_DETECT_ACTION = 'akcelerasi satu klik'

    exports.ENV_DETECT_KILLING = 'optimizing'

    exports.ENV_DETECT_KILL_COMPLETE = 'teroptimisasi dengan sukses'

    exports.ENV_DETECT_PROCESS = 'prosedur yang direkomendasikan untuk menutup'

    /**
     * =================================================
     * CDN 厂商名称
     * =================================================
     */

    exports.CDN_DNION = 'imperial alliance'

    exports.CDN_NET_CENTER = 'penduduk jaringan'

    exports.CDN_CHINA_CACHE = 'lan xun'

    /**
     * =================================================
     * 录制
     * =================================================
     */

    exports.RECORD_COLLECTS_LOCAL_RECORD = 'rekaman lokal'

    exports.RECORD_COLLECTS_CLOUD_RECORD = 'rekaman awan'

    exports.RECORD_COLLECTS_ALL_RECORD = 'rekaman awan lokal + awan'

    exports.RECORD_COLLECTS_CLOUD_RECORD_LIST = 'urus pemutaran awan'

    exports.RECORD_COLLECTS_PRE_START_INFO = 'mari kita mulai rekaman kursus'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME
        = 'waktu akhir kursus telah berlalu. hanya rekaman lokal dapat digunakan'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_WEB = 'waktu akhir kursus telah berlalu. tidak dapat direkam di awan'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_PAUSE
        = 'waktu akhir kursus telah melebihi 15 menit. setelah rekaman awan ditangguh, itu akan berakhir secara otomatis. anda ingin berakhir?'

    exports.RECORD_COLLECTS_CLOUD_RECORD_PAUSING_OVER_TIME
        = 'jika rekaman tidak dimulai dalam 15 menit setelah akhir kursus, rekaman awan akan berakhir secara otomatis. silakan perhatikan'

    exports.CLOUD_RECORD_OVER_TIME_WARNING_INFO_BTN = 'aku mengerti!'

    exports.END_RECORD_COLLECTS_PAUSE_RECORD = 'suspend'

    exports.END_RECORD_COLLECTS_STOP_RECORD = 'hentikan!'

    exports.END_RECORD_THEN = 'tidak dihasilkan saat ini'

    exports.END_RECORD_START_PLAYBACK = 'mulai membangun'

    exports.ALERT_STOP_PUSH_RECORD = 'apakah anda ingin mengakhiri rekaman streaming screenshot?'

    /**
     * =================================================
     * 录课设置
     * =================================================
     */

    exports.RECORD_SETTINGS_TITLE = 'menetapkan rekaman tentu saja'

    exports.RECORD_SETTINGS_AUTO_START = 'buka secara otomatis setelah kelas'

    exports.RECORD_SETTINGS_AUTO_START_LOCAL = 'rekaman lokal'

    exports.RECORD_SETTINGS_AUTO_START_CLOUD = 'rekaman awan'

    exports.RECORD_SETTINGS_RECORD_MODE = 'mod rekaman kursus'

    exports.RECORD_SETTINGS_RECORD_MODE_PART = 'rekam jendela'

    exports.RECORD_SETTINGS_RECORD_MODE_FULLSCREEN = 'rekam layar penuh'

    exports.RECORD_SETTINGS_PATH = 'simpan video rekaman pelajaran ke'

    // exports.RECORD_SETTINGS_REMEMBER = '记住选择（可到“更多 - 录课设置”中修改）';

    exports.RECORD_SETTINGS_LOCATION_TIP = 'ini dapat diubah dalam "lebih - pengaturan rekaman"'

    /**
     * =================================================
     * 云端录制
     * =================================================
     */

    exports.CLOUD_RECORD_CONFIRM_START
        = 'apakah anda ingin memulai rekaman kelas awan dan secara otomatis menghasilkan playback kursus setelah kelas?<br />(saat ini, rekaman awan tidak didukung selama kelas)'

    exports.CLOUD_RECORD_START_TIP_SDK
        = 'rekam awan direkam di server awan, dan rekaman lokal tidak disimpan<br />'
        + 'permainan kursus secara otomatis dihasilkan 10 menit setelah akhir kursus.<br />'

    exports.PUSH_RECORD_START_TIP_SDK
        = 'penangkapan streaming layar perlu menjaga klien terbuka dan layar penuh.<br />'
        + 'berkas rekaman kursus tidak disimpan lokal, dan playback kursus akan secara otomatis dihasilkan 10 menit setelah akhir kursus<br />'
        + 'hal yang membutuhkan perhatian:<br />'
        + '    1. tolong jangan mematikan speaker keras di ujung rekaman, jika tidak ada suara yang dapat direkam;<br />'
        + '    2. silakan jangan memindahkan klien keluar dari jendela rekaman, jika tidak bagian yang dibuang dari rekaman akan menunjukkan layar hitam;'

    exports.ALERT_PUSH_RECORD_NETWORK_ERROR = 'karena jaringan mungkin terputus, silakan periksa jaringan dan coba lagi'

    exports.CLOUD_RECORD_OVERTIME_STOP_TIP
        = 'waktu akhir kursus telah melebihi 8 jam, dan rekaman awan akan berhenti secara otomatis'

    exports.CLOUD_RECORD_PRE_START_TIP = 'mulai rekaman awan dan secara otomatis menghasilkan playback setelah kelas'

    exports.CLOUD_RECORD_OVERTIME_TIP = 'setelah waktu akhir dari kursus, anda tidak dapat membuka rekaman awan'

    exports.CLOUD_RECORD_RESTART_TIP
        = 'jika anda perlu menghentikan rekaman selama kelas, anda dapat klik menghentikan rekaman, dan klik rekaman lagi ketika anda perlu melanjutkan'

    exports.CLOUD_RECORD_WITHOUT_TEACHER_WARNING = 'guru tidak ada di ruang tamu. dilarang untuk mulai merekam awan'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGININ_SUCCESS = 'jawabannya adalah sukses'

    /**
     * =================================================
     * 磁盘空间
     * =================================================
     */

    exports.NET_DISK_INFO_TITLE = 'tip'

    exports.NET_DISK_INFO_BTN = 'aku mengerti!'

    exports.NET_DISK_INFO_POOR_PREFFIX = 'ruang penyimpanan awanmu terbatas'

    exports.NET_DISK_INFO_POOR_SUFFIX
        = 'mb, when the space is full, you will not be able to upload the courseware, please<a target="_blank" href="/teacher_center/storage_space">membeli</a>lebih ruang penyimpanan awan atau<a target="_blank" href="/teacher_center/netdisk">aman</a>berkas tak berguna'

    exports.NET_DISK_INFO_POOR_WRITE_PREFFIX = 'ruang penyimpanan awanmu terbatas'

    exports.NET_DISK_INFO_POOR_WRITE_SUFFIX = 'mb, tidak akan dapat menggunakan rekaman awan,'

    exports.NET_DISK_INFO_EMPTY
        = 'ruang penyimpanan awan anda tidak cukup, tidak dapat mengunggah saluran kursus saat ini, silakan mengunduhnya segera<a target="_blank" href="/teacher_center/storage_space">membeli</a>lebih ruang penyimpanan awan atau<a target="_blank" href="/teacher_center/netdisk">aman</a>berkas tak berguna'

    exports.NET_DISK_INFO_EMPTY_WRITE_PREFFIX = 'ruang penyimpanan awan anda telah melebihi batas'

    exports.NET_DISK_INFO_EMPTY_WRITE_SUFFIX = 'mb, tidak akan dapat menggunakan rekaman awan,'

    exports.NET_DISK_INFO_EXCEED_WRITE_PREFFIX = 'ruang penyimpanan awan anda telah melebihi batas'

    exports.NET_DISK_INFO_EXCEED_WRITE_SUFFIX = 'mb, rekaman awan tidak lagi tersedia,'

    /**
     * =================================================
     * 用户列表更多选项按钮
     * =================================================
     */

    exports.MORE_SETTINGS_BUTTON_FORBID_SEND_MESSAGE = 'tidak ada percakapan'

    exports.MORE_SETTINGS_BUTTON_UNFORBID_SEND_MESSAGE = 'izinkan percakapan'

    /**
     * =================================================
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'layanan streaming pihak ketiga'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'alamat streaming rtmp:'
    exports.LABLE_SERVER_STATUS_NORMAL = 'layanan streaming normal'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'maju data audio'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'tekan pengecualian layanan streaming'
    exports.LABLE_SERVER_STATUS_PREPARING = 'persiapan server'

    exports.BUTTON_REFRESH_LIST = 'senarai segar'
    exports.BUTTON_COPY_URI_OF_SERVER = 'salin'
    exports.BUTTON_RESTART_SERVER = 'mulai ulang layanan'
    exports.BUTTON_START_TRANPONDING_STREAM = 'mulai mengirim'
    exports.BUTTON_STOP_TRANPONDING_STREAM = 'hentikan mengirim'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'nama aliran'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'kode video'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = 'resolusi video'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = 'audio coding'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = 'sampel audio'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = 'keadaan'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'tidak ada data'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = 'menghantar'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'aku tidak akan mendukungnya'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = 'tidak dihantar'

    exports.RESTART_SERVER_FAILED_TIP = 'pemulaan ulang layanan gagal'
    exports.COPY_SUCCESS_TIP = 'salin berhasil'
    exports.PUSH_STREAM_FAILED_TIP = 'forwarding stream failed'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'tidak dapat mendapatkan alamat server'

    exports.STREAM_INFO_MARK_IS_TRANSPONDING = 'putar'

    exports.INFO_NO_DATA_FROM_STREAM
        = 'tidak ada data dalam aliran pihak ketiga. silakan periksa perangkat dan jaringan, atau memulai ulang layanan'

    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'papan putih / saluran kursus'
    exports.ASSIST_CAMERA = 'kamera bantuan'
    exports.SCREEN_SHARE = 'pembahagian layar'

    exports.CLOSE_MEDIA_BEFORE_DETECT = 'tolong berhenti main berkas audio dan video dulu'
    exports.CLOSE_DESKTOP_SHARE_BEFORE_DETECT = 'silakan matikan pembagian layar pertama'

    exports.SETTING_CAMERA_DISABLE = 'kamera sedang digunakan, pengaturan tidak dapat diubah sementara'
    exports.SETTING_ASSIST_CAMERA_DISABLE = 'kamera bantuan sedang digunakan, pengaturan tidak dapat diubah sementara'
    exports.SETTING_SHARE_DISABLE = 'pembahagian desktop sedang digunakan, tidak dapat mengubah pengaturan sementara'

    /**
     * =================================================
     * 邀请发言
     * =================================================
     */
    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INIT = 'invite the wheat'

    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INVITING = 'batalkan undangan'

    exports.MORE_SETTINGS_MARK_INVITING = 'undangan dalam proses'

    exports.MORE_SETTINGS_MARK_SPEAKING = 'berbicara'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_INIT = 'gandum paksa'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_OPENING = 'membuka'

    exports.MORE_SETTINGS_BUTTON_SPEAK_INVITE_UNSUPPORTED_HOVER_TIP
        = 'pengguna menggunakan versi web dan tidak mendukung undangan ke mac'

    exports.BUTTON_OPEN_WEBCAM = ' hidupkan kameranya. '

    /**
     * =================================================
     *
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'layanan streaming pihak ketiga'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'alamat streaming rtmp:'
    exports.LABLE_SERVER_STATUS_NORMAL = 'layanan streaming normal'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'maju data audio'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'tekan pengecualian layanan streaming'

    exports.BUTTON_COPY_URI_OF_SERVER = 'salin'
    exports.BUTTON_RESTART_SERVER = 'mulai ulang layanan'
    exports.BUTTON_START_TRANPONDING_STREAM = 'mulai mengirim'
    exports.BUTTON_STOP_TRANPONDING_STREAM = 'hentikan mengirim'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'nama aliran'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'kode video'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = 'resolusi video'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = 'audio coding'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = 'sampel audio'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = 'keadaan'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'tidak ada data'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = 'menghantar'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'aku tidak akan mendukungnya'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = 'tidak dihantar'

    exports.RESTART_SERVER_FAILED_TIP = 'pemulaan ulang layanan gagal'
    exports.COPY_SUCCESS_TIP = 'salin berhasil'
    exports.PUSH_STREAM_FAILED_TIP = 'forwarding stream failed'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'tidak dapat mendapatkan alamat server'
    exports.STREAM_INFO_MARK_IS_TRANSPONDING = 'putar'
    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'papan putih / saluran kursus'
    exports.ASSIST_CAMERA = 'kamera bantuan'
    exports.SCREEN_SHARE = 'pembahagian layar'

    exports.SIGNIN_FORBID
        = 'panggilan roll berikutnya hanya dapat dimulai satu menit setelah penghitungan panggilan roll terakhir'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGNIN_FORBID
        = 'panggilan roll berikutnya hanya dapat dimulai satu menit setelah penghitungan panggilan roll terakhir'

    exports.BEGIN_EXAM_TIP = 'apakah anda yakin untuk membuka ujian?'

    exports.END_EXAM_TIP = 'apakah anda yakin untuk menutup tes?'

    exports.BEGIN_EXAM_INFO = 'pemeriksaan masuk telah dibuka'

    exports.END_EXAM_INFO = 'the entrance examination has been closed'

    exports.UNKNOW_EMOTION = '[ekspresi tidak didukung]'

    /**
     * =================================================
     * 升级浏览器提示
     * =================================================
     */
    exports.UPGRADE_CLOSE_POWER_SAVING_MODE = 'matikan mode penyimpanan daya'

    exports.UPGRADE_NOTICE_SAFARI
        = 'anda menggunakan perambar safari, pastikan mematikan mode penyimpanan daya untuk memastikan kelas normal audio dan video'

    exports.UPGRADE_SAFARI_SETTING = 'pengaturan safari - lanjutan'

    exports.UPGRADE_CANCEL_CHECK = 'nyahpilih'

    exports.UPGRADE_NOTICE_NO_FLASH
        = 'sistem mendeteksi bahwa komponen flash anda tidak bekerja dengan benar, yang akan menyebabkan fungsi kelas tidak bekerja dengan benar.<br />Silakan coba memainkan video di bawah. Jika Anda tidak bisa memainkannya, silakan mengunduhnya'

    exports.UPGRADE_BROWSER_GOOGLE = 'google browser'

    exports.UPGRADE_FAIL_CONTACT_TEL
        = 'jika masalah tidak dapat diselesaikan, silakan hubungi layanan pelanggan 4000-910-910'

    exports.UPGRADE_CLOSE_POWER_SAVING_MODE_CHROME
        = 'anda menggunakan versi terbaru dari perambar chrome. silakan matikan mode penyimpanan daya untuk memastikan bahwa audio dan video dapat digunakan secara biasa'

    exports.UPGRADE_CHROME_SETTING_STEP_ONE = 'masukkan halaman pengaturan plug-in chrome'

    exports.UPGRADE_CHROME_SETTING_STEP_TWO = 'semak selalu membiarkan pemain adobe flash berjalan'

    exports.UPGRADE_REFRESH_LIVE_ROOM = 'segar ulang halaman kelas'

    exports.UPGRADE_NO_FLASH_CAN_NOT_START = 'pelayar anda tidak terpasang flash-in, tidak akan dapat ke kelas normal'

    exports.UPGRADE_INSTALL_GUIDE = 'panduan pemasangan'

    exports.UPGRADE_TAKE_A_LOOK = 'lihatlah dulu.'

    exports.UPGRADE_NOTICE_TO_LOW_BROWSER
        = 'sulit bagi pelayar anda untuk mengalami fungsi yang kuat dari kelas online. ini direkomendasikan untuk menggantikan pelayar maju'

    exports.UPGRADE_ENABLE_NEW_TECH = 'gunakan teknologi terbaru sekarang'

    exports.UPGRADE_BY_REJECT = 'mari kita membuatnya bekerja'

    exports.FLASH_CAN_NOT_USE = 'pemuatan plug-in flash web gagal, anda dapat mencoba operasi berikutnya'

    exports.CLICK_ALLOW_TIP = 'dan pilih "ijinkan" pada prompt'

    exports.CLICK_INSTALL_TIP = 'dan memasang'

    exports.CLICK_TIP = 'klik'

    exports.ALLOW_FLASH = 'aktifkan flash'

    exports.DOWNLOAD_FLASH = 'download flash'

    /**
     * =================================================
     * 管理课件
     * =================================================
     */

    exports.DOCUMENT_UPLOAD = 'menguasai saluran kursus'

    exports.DOCUMENT_UPLOAD_ING = 'jalur sedang mengunggah'

    exports.DOCUMENT_UPLOAD_FROM_NETDISK = 'tambah dari database'

    exports.DOCUMENT_HAS_ADD = 'jalur ditambah'

    exports.DOCUMENT_SUPPORT_FORMAT = 'dukungan ppt, pptx, doc, docx, jpg, png, pdf'

    exports.DOCUMENT_MOVE_UP = 'naik ke atas'

    exports.DOCUMENT_MOVE_DOWN = 'pindah ke bawah'

    exports.DOCUMENT_UPLOAD_STAUS_CACEL = 'batalkan pengiriman'

    exports.DOCUMENT_UPLOAD_STAUS_ING = 'memuat naik'

    exports.DOCUMENT_UPLOAD_STAUS_FAIL = 'upload gagal'

    exports.DOCUMENT_TRANSFORM_STATUS_FAIL = 'transcoding gagal'

    exports.DOCUMENT_TRANSFORM_STATUS_WAIT = 'menunggu transkode'

    exports.DOCUMENT_TRANSFORM_ING = 'transcoding'

    exports.DOCUMENT_HAS_ADD_STATUS = 'ditambah'

    exports.DOCUMENT_TRANSFORM_NOTICE
        = 'untuk dokumen yang disunting wps, silakan mengubahnya menjadi pdf dan mengubahnya'

    exports.DOCUMENT_DEMO_LINK = 'klik di sini untuk melihat tutorial konversi'

    exports.DOCUMENT_CAN_USE_STATUS = 'tersedia'

    exports.DOCUMENT_HAS_BE_CHECKED = 'dipilih'

    exports.DOCUMENT_UPLOAD_ING_NOTICE = 'berkas sedang diunggah, tunggu'

    exports.DOCUMENT_MANAGEMENT = 'manajemen jalur kursus'

    exports.DOCUMENT_BACK_TO_MANAGEMENT = 'kembali ke manajemen jalur jalur'

    exports.SURVEY_PLEASE_INPUT_ANSWER = 'silakan masukkan jawabannya'

    exports.PLACEHOLDER_NOITCE_CONTENT = 'silakan masukkan isi utama pengumuman'

    exports.PLACEHOLDER_NOITCE_LINK = 'silakan masukkan hubungan lompatan pengumuman (pilihan)'

    exports.PLACEHOLDER_NOITCE_GROUP_CONTENT = 'silakan masukkan teks pemberitahuan'

    exports.PLACEHOLDER_NOITCE_GROUP_LINK = 'silakan masukkan hubungan lompatan pemberitahuan (pilihan)'

    exports.NOTICE_LINK_ERROR_HINT = 'format link yang salah'

    exports.KICK_OUT = 'kick keluar dari kelas'

    exports.ENTER_CLASSROOM_KICKED_OUT = 'setelah diminta keluar dari kelas, anda tidak bisa masuk lagi'

    exports.KICKED_OUT_TIP = 'anda telah diminta keluar dari kelas'

    exports.KICKED_OUT_BY_AUDITION_END_TIP
        = 'waktu audisi anda habis. jika anda ingin terus menghadiri kelas, silakan mendaftar dan berpartisipasi!'

    exports.KICKED_OUT_BY_ROOM_DISABLED_TIP
        = 'ruang tamu saat ini telah dinonaktifkan. anda telah diundang keluar dari ruang tamu'

    exports.ALERT_KICK_OUT_AFTER_CLASS_30_MINUTES = 'selamat datang untuk menontonnya lain kali'

    exports.CLASS_END_TIP = 'guru keluar dari kelas ~'

    exports.CLASS_ENDED = 'sudah waktunya untuk menyelesaikan kelas'

    exports.TIME_BEFORE_CLASS_END = 'Masih ada ${time} detik sebelum keluar kelas selesai'

    exports.CLASS_HAS_BEGAN_TIME = 'Kelas dimulai ${hours} jam ${minutes} menit ${seconds} detik'

    exports.WARNING_APPLY_SPEAK_STATUS_SWITCH_FREQUENT = 'tolong jangan sering menukar keadaan berbicara'

    /**
     * =================================================
     * 设置主讲人
     * =================================================
     */

    exports.YOU_ARE_PRESENTER = 'anda diatur sebagai guru catatan kunci'

    exports.YOU_ARE_NOT_PRESENTER = 'anda telah ditarik dari otoritas pembaca'

    exports.SET_USER_PRESENTER_TIP = 'Presenter telah beralih ke ${username}'

    exports.CANCEL_USER_PRESENTER_TIP = 'Izin dosen pengguna ${username} telah ditarik'

    exports.CANCEL_USER_PRESENTER_WHEN_OUT_TIP = 'Pengguna ${username} keluar dari kelas, dan izin dosen telah dicabut'

    exports.OPEN_CAMERA_FAIL_TIP = 'gagal menyalakan kamera'

    exports.OPEN_MIC_FAIL_TIP = 'gagal menyalakan mikrofon'

    exports.PRESENTER_IN = 'pelajar telah memasuki kelas'

    exports.PRESENTER_OUT = 'pelajar telah meninggalkan kelas'

    exports.BJY_SUPPORT = 'baijia cloud provides live broadcast service'

    exports.CONFIRM_SEND_PRIZE = 'do you want to send red packets?'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_CPU
        = 'dideteksi bahwa tingkat penggunaan cpu dari komputer terlalu tinggi. untuk memastikan siaran langsung normal, silakan tutup perangkat lunak yang tidak berhubungan dengan siaran langsung'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_MEMORY
        = 'dideteksi bahwa tingkat penggunaan memori komputer terlalu tinggi. untuk memastikan siaran langsung normal, silakan tutup perangkat lunak yang tidak berhubungan dengan siaran langsung'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_BOTH
        = 'dideteksi bahwa tingkat penggunaan cpu dan memori terlalu tinggi. untuk memastikan siaran langsung normal, silakan tutup perangkat lunak yang tidak berhubungan dengan siaran langsung'

    exports.NETWORK_BAD_WARNING = 'kondisi jaringan buruk, audio dan video mungkin terjebak'

    exports.CHANGE_LINK_TYPE_DUE_TO_NETWORK
        = 'kondisi jaringan terlalu buruk, mencoba untuk berganti ke link lain untuk anda.'

    exports.LABEL_WHITEBOARD_FILL = 'isi'

    exports.LABEL_WHITEBOARD_STROKE = 'pukulan'

    exports.LABEL_FORBID_RAISE_HAND = 'tidak ada tangan'

    exports.INFO_FORBID_RAISE_HAND = 'hand raising has been banned'

    exports.INFO_UNFORBID_RAISE_HAND = 'tunjukkan tangan diperbolehkan'

    exports.INFO_FORBID_OPEN_MIC = 'mikrofon dinonaktifkan'

    exports.INFO_UNFORBID_OPEN_MIC = 'mikrofon diaktifkan'

    exports.INFO_TEACHER_FORBID_RAISE_HAND = 'hand raising has been banned'

    exports.LABEL_GUEST = 'pengguna'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_NEW = 'lanjutkan rekaman awan sebelumnya atau memulai rekaman baru?'

    exports.INFO_BUTTON_CONTINUE = 'teruskan merekam'

    exports.INFO_BUTTON_START_NEW = 'rekaman baru'

    exports.LABEL_GUEST = 'pengguna'

    exports.SELECT_PROGRAM = 'silakan pilih program untuk dibagi'

    exports.CONFIRM_REMOVE_DOCUMENT_TRANSFORM_ING = 'dokumen ini sedang mengkode. anda yakin ingin menghapusnya?'

    exports.BUTTON_UPLOAD_PPT_DOCUMENT = 'ppt dinamik'

    exports.BUTTON_CHROME_FLASH_USER_GUIDE1_COMPLETE = 'seting selesai'

    exports.PRE_STEP = 'langkah terakhir'

    exports.NEXT_STEP = 'langkah berikutnya'

    exports.TIP_CHROME_FLASH_MORE_SETTING = 'metode di atas masih belum memecahkan masalah?'

    exports.VIEW_MORE_SETTING = 'lihat lebih banyak tentang pengaturan'

    exports.LABEL_NO_LONGER_REMIND = 'jangan meminta lagi'

    exports.BUTTON_CLOSE = 'tutup'

    exports.CHROME_UPGRADE_INSTRUCTION
        = 'ada pengecualian dalam pemain flash dalam perambang anda. silakan tetapkan dengan benar menurut metode berikut sebelum siaran langsung'

    exports.CHROME_TIP_FLASH_SETTING_SET = '1. tetapkan area identifikasi kotak biru dalam figur di bawah ke'

    exports.CHROME_TIP_FLASH_SETTING_ALLOW = 'selalu mengizinkan di situs ini'

    exports.CHROME_TIP_FLASH_SETTING_THEN = ', dan kemudian'

    exports.CHROME_TIP_FLASH_SETTING_REFRESH = 'segar'

    exports.CHROME_TIP_FLASH_SETTING_BROWSER = 'pelayar'

    exports.CHROME_TIP_FLASH_DOWNLOAD
        = '2. jika halaman masih dipaparkan setelah menetapkan, anda perlu mengunduh dan menginstal pemain flash terbaru'

    exports.DOWNLOAD_FLASH = 'turunkan sekarang'

    exports.CHROME_MORE_SETTING_FLASH = 'lihat lebih banyak tentang pengaturan'

    /**
     * apple 帮助信息
     */
    exports.APPLE_HELP_INFO = 'call 8610-85255961 or email to yangdongliu@apple.com'

    exports.TIP_DO_NOT_SUPPORT_LOW_VERSION_IE = 'woo ~ versi pelayarmu terlalu rendah ~ kami tidak mendukung versi ie9!'

    exports.TIP_LOW_VERSION_IE_UPDATE_BROWSER = '1. silakan meningkatkan pelayar anda'

    exports.TIP_LOW_VERSION_IE_DOWNLOAD_CHROME = 'turunkan sekarang'

    exports.TIP_LOW_VERSION_IE_CHANGE_MODE
        = '2. jika anda menggunakan 360, qq, sogou dan pelayar lain, silakan ganti ke mode kecepatan'

    exports.TIP_LOW_VERSION_IE_CHANGE_BROWSER = '3. ubah pelayar lain'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_LIVE = 'hidup di awan'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_CLASSROOM = 'kelas awan'

    exports.TIP_INVITATION_NAME_INPUT = 'silakan masukkan gelaran anda:'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE = 'silakan masukkan nomor ponsel anda:'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE_WRONG = 'silakan masukkan nomor ponsel yang tepat'

    exports.PLACEHOLDER_INVITATION_JOINCODE_INPUT = 'anda dapat meminta manajer langsung anda untuk kode berpartisipasi'

    exports.TIP_INVITATION_GET_JOINCODE = 'silakan masukkan kode partisipasi anda:'

    exports.TIP_INVITATION_NAME_SHOULD_NOT_BE_EMPTY = 'nama panggilan tidak dapat kosong'

    exports.TIP_INVITATION_MOBILE_SHOULD_NOT_BE_EMPTY = 'nomor ponsel tidak dapat kosong'

    exports.TIP_INVITATION_JOINCODE_SHOULD_NOT_BE_EMPTY = 'kode partisipasi tidak dapat kosong'

    exports.TIP_INVITATION_JOINCODE_IS_NOT_RIGHT = 'silakan masukkan kode parteċipasi yang tepat'

    exports.LOCAL_RECORD_PATH_NULL = 'silakan pilih jalur penyimpanan video lokal'

    exports.INFO_LOCK_SCREEN = 'kunci siswa terbuka'

    exports.INFO_UNLOCK_SCREEN = 'tidak terkunci'

    exports.INFO_LOCK_SCREEN_STUDENT
        = 'guru telah membuka kunci siswa, anda tidak dapat operasi perangkat lunak lain saat ini'

    exports.LABEL_NERVER_PRINT = 'jangan meminta lagi'

    exports.LABEL_LOCK_SCREEN_OPEN = 'buka'

    exports.INFO_LOCK_SCREEN_FIRST
        = 'setelah membuka kunci siswa, siswa yang menggunakan klien windows hanya dapat menggunakan perangkat lunak langsung ini.'

    exports.INFO_COLLECT_SYSTEM_SOUND_FIRST
        = 'untuk menghindari mendengar suara suara, ketika anda menyalakan sistem akuisisi suara, anda dapat mengurangi suara pembicara atau diam pembicara.'

    exports.MEDIA_PLAYER_LOAD_FILE_FAILED
        = 'file loading failed. please make sure the file is a media file or open another file'

    exports.CLASS_SWITCH_PARENT_TIP = 'masukkan kelas kecil'

    exports.CLASS_SWITCH_CHILD_TIP = 'masukkan kelas besar'

    exports.PARENT_CLASS_SWITCH_PARENT_TIP = 'diskusi kelompok'

    exports.PARENT_CLASS_SWITCH_CHILD_TIP = 'pertemuan kelas besar'

    exports.CLASS_SWITCH_PARENT_SUCCESS_TIP = 'ini telah masuk ke kelas besar'

    exports.CLASS_SWITCH_CHILD_SUCCESS_TIP = 'kelas kecil'

    exports.CLASS_SWITCH_ROOM_SERVER_WAITING = 'bertukar kamar, menghubungkan kembali'

    exports.CLASS_SWITCH_TIP = 'apakah anda yakin untuk menukar ruang kelas?'

    exports.CLASS_SWITCH_TIP_CLOUD_RECORD
        = '<div class="confirm-class-switch-tip">setelah memasuki kelas besar, rekaman awan akan dihentikan, dan anda harus kembali ke kelas kecil untuk menghasilkan playback</div>'

    exports.CLASS_SWITCH_MEDIA_PLAYER_TIP = 'silakan berhenti main audio dan video lokal dulu'

    exports.CLASS_SWITCH_THIRD_PUSH_TIP = 'tolong hentikan pihak ketiga streaming pertama'

    exports.CLASS_SWITCH_SCREEN_SHAR_TIP = 'tolong hentikan berbagi desktop pertama'

    exports.CLASS_SWITCH_VIDEO_LAYOUT_TIP = 'tolong hentikan layout video pertama'

    exports.CLASS_SWITCH_EXAM_TIP = 'tolong hentikan pemeriksaan kelas pertama'

    exports.CLASSROOM_ENTER_COUNT_DOWN_LABEL = 'live countdown:'

    /**
     * 图片添加至文档
     */
    exports.LABEL_IMAGE = 'gambar'

    exports.LABEL_IMAGE_VIEW = 'prapapar gambar'

    exports.LABEL_IMAGE_DOWNLOAD = 'muat turun gambar'

    exports.LABEL_ADD_TO_DOCUMENT = 'tambah ke saluran kursus'

    exports.LABEL_OPEN_ON_BLACKBOARD = 'tambah dan buka'

    exports.INFO_IMAGE_ADD_SUCCESS = 'gambar telah berhasil ditambah ke daerah dokumen'

    exports.INFO_IMAGE_ADD_FAIL = 'gambar tidak berhasil ditambah ke dokumen'

    exports.WARING_IMAGE_HAS_ADDED = 'gambar telah ditambah ke dokumen, tolong jangan menambahnya berulang kali'

    exports.QRCODE_IMAGE_UPLOAD_DONE = 'Upload berhasil, tutup dalam ${countDown} detik...'

    /**
     * 问答提示
     */
    exports.INFO_QUESTION_ANSWERED = 'guru menjawab pertanyaanmu, pergi dan memeriksanya ~'

    exports.CONFIRM_CLOSE_QUSETION_ANSWER = 'anda masih memiliki isi yang tidak dikirim, anda yakin untuk menutupnya?'

    /**
     * 浏览器不兼容提示
     */
    exports.BROWSER_NOT_SUPPORT_TIP_IE = 'versi browser anda terlalu rendah, silakan meningkatkan ke ie10 atau lebih.'

    exports.BROWSER_NOT_SUPPORT_TIP_WECHAT
        = 'pelayar wechat masuk tidak didukung, silakan pergi ke pelayar lain untuk dibuka.'

    exports.BROWSER_NOT_SUPPORT_TIP_WEBRTC
        = 'pelayar anda tidak mendukung kursus webrtc. silakan gunakan pelayar chrome terbaru.'

    /**
     * 抽奖
     */

    exports.LOTTERY_STATUS_ING = 'di loteri, sisanya'

    exports.LOTTERY_COMMADN_ING_TIP
        = 'saat ini, loteri masih dalam proses. apakah anda ingin membuka loteri di depan dan mengumumkan daftar pemenang'

    exports.LOTTERY_BUTTON_CONTINUE = 'lanjutkan menggambar'

    exports.LOTTERY_BUTTON_BEGIN_NOW = 'mari kita menarik hadiahnya sekarang'

    exports.LOTTERY_BEGIN_IN_CHAT = 'masukkan sandi dalam area percakapan untuk berpartisipasi dalam loteri'

    exports.LOTTERY_MESSAGE_TIP_BEFORE = 'input'

    exports.LOTTERY_MESSAGE_TIP_AFTER = 'dalam gambar beruntung'

    /**
     * 音频设备统一切换
     */
    exports.COMBINED_AUDIO_DEVICE_SWITCH_CONFIRM
        = 'mikrofon / speaker ditemukan di perangkat yang sama, apakah diaktifkan?'

    exports.COMBINED_AUDIO_DEVICE_SWITCH_OK = 'aktifkan'

    /*
     * 授权画笔
     */
    exports.PAINT_AUTHORIZE_TIP_ENABLE = 'guru telah mengijinkanmu menggunakan berus'

    exports.PAINT_AUTHORIZE_TIP_DISABLE = 'guru telah menarik izin berus anda'

    /*
     * 切换布局
     */
    exports.SWITCH_LAYOUT_METTING = 'beralih ke layout galeri'

    exports.SWITCH_LAYOUT_MONKEY = 'beralih ke layout 3 layar'

    exports.CHECK_GRAYSCALE_FAIL
        = 'gagal mengganti lingkungan. silakan hubungi dukungan teknis awan baijia untuk memecahkan masalah'

    exports.SWITCH_LAYOUT_SINGLE = 'beralih ke layout video tunggal'

    exports.DEVICE_IS_USING = 'perangkat sedang digunakan'

    exports.LINK_SHARE_SUCCESS = 'link disalin ke papan klip'

    exports.SHARE_LABEL_TITLE = 'pembahagian layar'

    exports.TEXT_NOTICE_LABEL_TITLE = 'notis tertulis'

    exports.IMG_NOTICE_LABEL_TITLE = 'pengumuman foto'

    exports.USER_TAB_ALL = 'semua anggota'

    exports.USER_TAB_FORBID = 'pengguna dilarang'

    exports.USER_TAB_KICKOUT = 'pengguna dikeluarkan'

    exports.RECORD_COMPLETE_LIVE_TIP = 'rekaman kursus selesai,'

    exports.OPEN_RECORD_FILE = 'buka berkas rekor kelas lokal'

    exports.HTTP_REQUEST_ERROR = 'permintaan jaringan gagal, tolong periksa jaringan'

    /*
     * 权限控制
     */
    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_ENABLE = 'guru telah mengijinkanmu mengendalikan dokumen'

    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_DISABLE = 'guru telah menarik hak kontrol dokumen anda'

    exports.AUTH_MANAGEMENT_LABEL_TITLE = 'manajemen otoritas'

    exports.TEXT_NO_SPEAK_AUTH = 'anda tidak punya izin untuk pergi ke gandum saat ini'

    exports.TEXT_SPEAK_AUTH_NO = 'guru telah menarik izinmu untuk pergi ke gandum'

    exports.TEXT_NO_NOTICE_AUTH = 'anda tidak punya hak untuk mempublikasikan pengumuman saat ini'

    exports.TEXT_NOTICE_AUTH_NO = 'guru telah menarik otoritas pemberitahuan anda'

    exports.TEXT_NO_DOCUMENT_UPLOAD_AUTH = 'anda tidak punya izin untuk mengunggah dokumen saat ini'

    exports.TEXT_DOCUMENT_UPLOAD_AUTH_NO = 'guru telah menarik izin upload dokumen anda'

    exports.TEXT_NO_PAINTER_AUTH = 'anda tidak memiliki izin berus saat ini'

    exports.TEXT_PAINTER_AUTH_NO = 'guru telah mengambil kembali izin berus anda'

    exports.TEXT_NO_CLASS_START_END_AUTH = 'anda tidak punya hak untuk menghadiri atau meninggalkan kelas saat ini'

    exports.TEXT_NO_CLOUD_RECORD_AUTH = 'anda tidak punya izin untuk merekam di awan'

    exports.NO_RECORD_AUTH
        = 'untuk menggunakan fungsi rekaman awan, anda perlu membuka awan pada garis produk permintaan pertama. silakan kontak organisasi untuk membukanya!'

    exports.TEXT_NO_FORBID_AND_KICK_AUTH = 'kau tidak punya hak untuk melarang dan menendang orang sekarang'

    exports.TEXT_NO_QUIZ_AUTH = 'Anda saat ini tidak memiliki izin untuk mempublikasikan pertanyaan'

    exports.CONFIRM_RELOAD = 'kau yakin ingin masuk kelas lagi?'

    exports.CONFIRM_CLOSE_ROOM
        = 'apakah anda yakin anda ingin menghentikan kelas?</br>setelah suspensi, semua pengguna akan diusir keluar dari kelas, dan kelas akan ditutup dan tidak dapat dimasukkan kembali'

    exports.EXTENSION_LABEL_TITLE = 'pemalam berbagi layar dalam penyihir instalasi'

    exports.FORBID_LIVE = 'hentikan siaran'

    exports.AUTO_PLAY_TITLE = 'masuk '

    exports.SCREEN_SHARE_ERROR = 'pembahagian layar gagal, silakan segar dan coba lagi'

    exports.PUBLISH_ERROR = 'gagal mempublikasikan video, silakan segar dan coba lagi'

    exports.SUBSCRIBE_ERROR = 'gagal memuat video, tolong segar dan coba lagi'

    exports.WEBRTC_SERVER_CONNECT_TIMEOUT = 'waktu kehabisan koneksi server video, silakan segar-segar dan coba lagi'

    exports.CAN_NOT_SCREEN_SHARE_WHEN_CLASS_END = 'jalurnya berakhir. anda tidak bisa berbagi layar'

    exports.PPT_VIDEO_SWITCH_CONTENT_TIP
        = 'tukar posisi jendela video dan papan putih. apakah sisi siswa bertukar secara sinkronis?'

    exports.PPT_VIDEO_SWITCH_LOCAL = 'hanya tombol lokal'

    exports.PPT_VIDEO_SWITCH_ALL = 'penukaran sinkronis'

    exports.CLASS_HISTORY_BACK_TIP = 'kembali'

    exports.HISTORY_BACK_ALERT_TIP = 'Apakah akan meninggalkan ruang live?'

    exports.RESULT_SCOPE_JINGXI = 'koin emas'

    exports.TIP_ROOM_SERVER_LOGIN_KICKED_OUT = 'anda telah diusir keluar dari kelas dan tidak dapat mengganti kelas'

    exports.LOTTERY_TIME_STOP = 'berhenti menggambar'

    exports.LOTTERY_TIME_STOP_TIP = 'apakah anda yakin untuk menghentikan loteri?'

    exports.TEXT_LOTTERY_SUCCESS = 'anda telah berpartisipasi dalam gambar beruntung.'

    exports.TEXT_LOTTERY_COMMAND_FAIL = 'galat masukan sandi, silakan masukkan kembali'

    exports.TEXT_LOTTERY_CLOSE_NO_SUBMIT = 'anda belum mengirimkan informasi, anda yakin untuk menutupnya?'

    exports.TEXT_LOTTERY_TEACHER_OPENED = 'the lottery is in progress'

    exports.TEXT_VOTE_TEACHER_OPENED = 'saat ini memilih'

    exports.TEXT_TEACHER_TITLE = 'memulai suara'

    exports.CLASS_STATUS_STOP_WARMING_UP = 'berhenti memanaskan'

    exports.TEXT_DETELE_WHITEBOARD = 'hapus papan putih saat ini dan isi?'

    exports.INFO_PLAYER_LOW_UPLINK_AUDIO_BANDWIDTH
        = 'sistem telah mendeteksi bahwa mikrofon anda tidak bekerja dengan benar. silakan sambungkan perangkat lagi'

    exports.INFO_RED_PACKET_CREATE_FAIL = 'gagal membuat amplop merah'

    exports.CLEAR_ALL_SHAPE_TIP
        = '<p><icon>apa?</icon>apakah anda yakin anda ingin membersihkan mereka semua?</p><p>operasi ini akan membersihkan semua isi penyunting dan anotasi, dan tidak dapat dikembalikan.tolong operasikan dengan hati-hati!<p>'

    exports.CLEAR_ALL_SHAPE_OK_TIP = 'bersihkan semuanya'

    exports.CAN_NOT_PUSH_WEBRTC_STREAM
        = 'pelayar saat ini tidak mendukung mac, silakan gunakan chrome atau klien terbaru'

    exports.TEXT_FORBID_CLASS_START_END = 'ini bukan waktu untuk menyelesaikan kelas'

    exports.CONFIRM_EXIT_CLASSROOM_FORBID_END_CLASS = 'sekarang bukan akhir kelas, kau masih ingin berhenti?'

    exports.CONFIRM_LOCATE_PREV_PAGE_END_CLASS
        = 'kembali ke halaman sebelumnya akan mengakhiri kelas secara otomatis. apakah anda ingin kembali?'

    exports.CONFIRM_LOCATE_PREV_PAGE_EXIT_CLASSROOM
        = 'kembali ke halaman sebelumnya akan segera keluar dari kelas. apakah anda ingin kembali?'

    exports.BUTTON_SWITCH_MIX_MAIN_USER = 'tukar layout video'

    exports.TITLE_SIWTCH_MIX_MAIN_USER
        = 'setelah menukar, layar video yang para siswa lihat akan ditampilkan secara sinkronis'

    exports.MIX_USER_SCREEN_CHANGE_TIP = '${userName} telah dialihkan ke layar utama'

    exports.LOTTERY_HISTORY_LIST = 'rekaman menang'

    /**
     * 低版本 app 不支持作业功能提示
     */
    exports.ALERT_TITLE = 'tip'

    exports.ALERT_FIND_LOW_VERSION_APP_IN_CLASS_NOT_SUPPORT_HOMEWORK = 'terminal ponsel tidak mendukung fungsi ini.'

    exports.TIP_I_KONW = 'aku mengerti!'

    exports.BUTTON_AUTHORIZE_H5_PPT = 'jalur h5 yang diijinkan'

    exports.BUTTON_AUTHORIZE_H5_PPT_OFF = 'batalkan otorisasi'

    exports.TIP_AUTHORIZE_H5_PPT_ON = 'semua jalur h5 yang diijinkan'

    exports.TIP_AUTHORIZE_H5_PPT_OFF = 'jalur h5 telah dibatalkan'

    exports.WEBRTC_TYPE_CHANGE_TIP = 'ruangan ini telah menukar garis, akan masuk kembali ke ruangan, tolong tunggu'

    exports.TIP_DISABLE_CONTROLL_FORBID_ALL = 'guru telah membuka semua larangan'

    exports.TIP_NOT_ALLOW_AUTHORIZE_H5_PPT
        = 'Anda telah melarang para siswa untuk mengubah halaman dan tidak dapat mengijinkan jalur kursus'

    exports.TIP_CANCEL_AUTHORIZE_H5_PPT
        = 'Anda melarang mahasiswa untuk mengubah halaman, dan otorisasi kursus telah dibatalkan'

    /**
     * safari flv 拉流提示
     */
    exports.LABEL_SAFARI_FLV_PULL_TIPS
        = 'tidak bisa mendapatkan audio dan video langsung?buka "pengaturan situs ini..." dalam pelayar safari dan set autoplay untuk "mengizinkan semua autoplay".'

    /**
     * =================================================
     * 外接手机摄像头
     * =================================================
     */
    exports.DIALOG_TITLE_PHONE_CAMERA_QRCODE = 'pemindaian video langsung'

    exports.TIP_USE_PHONE_CAMERA_QRCODE = 'silakan gunakan aplikasi kelas awan untuk memindai kode secara langsung'

    exports.DIALOG_TITLE_STOP_PHONE_CAMERA = 'hentikan siaran langsung dari perangkat luar'

    exports.TIP_OPEN_MAIN_CAMERA = 'hidupkan kamera perangkat utama'

    /**
     * 屏幕共享音源选择
     */
    exports.SCREEN_SHARE_AUDIO_SELECT_TITLE = 'pilih sumber suara'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC = 'suara mikrofon berbagi'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC_TIPS = 'para mahasiswa akan mendengar mikrofon anda ketika layar dibagi'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM = 'suara sistem berbagi'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_1
        = 'para mahasiswa akan mendengar suara sistem anda ketika layar dibagi'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_2 = '(misalnya: prompt pesan qq, musik, video playback, dll.)'

    /**
     * =================================================
     * 美颜
     * =================================================
     */
    exports.DIALOG_TITLE_CLIP_IMAGE = 'screenshot'

    exports.TIP_INIT_BEAUTY_FAIL = 'inisialisasi program kecantikan gagal'

    exports.SETTING_LABEL_BEAUTY = 'beauty filter'

    exports.SETTING_LABEL_VIRTUAL_BG = 'latar belakang virtual'

    exports.SETTING_TIP_WEB_BEAUTY
        = 'Filter kecantikan<br/> 1, keindahan terbuka, ambil memori dan CPU tertentu; <br/>2, untuk menghindari Anda di halaman web, silakan aktifkan akselerasi perangkat keras; <br/>3. Jika Anda membutuhkan lebih banyak kecantikan & latar belakang virtual, efek lanjutan, silakan latar belakang dan gunakan di klien!'

    /**
     * =================================================
     * 选择显身 / 隐身
     * =================================================
     */
    exports.LABEL_ASSISTANT_VISIBLE_TIPS
        = 'jika anda adalah asisten mengajar kelas, silakan gunakan identitas pribadi anda untuk masuk. yang lain dapat melihat anda'

    exports.LABEL_ASSISTANT_HIDDEN_TIPS
        = 'jika anda adalah supervisor kelas atau asisten tur, silakan gunakan identitas tidak terlihat anda untuk memasuki. tidak ada orang lain dapat melihat anda'

    exports.LABEL_ASSISTANT_ENTER = 'masuk'

    /**
     * =================================================
     * 摄像机采集模式切换
     * =================================================
     */
    exports.HINT_CLIENT_VIDEO_CAPTURE_MODE_CHANGE_DIALOG_TEXT
        = 'pengaturan mode akuisisi kamera akan berfungsi setelah memulai ulang perangkat lunak. sekarang memulai ulang perangkat lunak?'

    /**
     * =================================================
     * 积分
     * =================================================
     */
    exports.BONUS_BUBBLE_TIP = 'integral'

    exports.BONUS_MY_POINTS = 'my points'

    exports.BONUS_POINTS_RANK = 'ranking titik'

    exports.BONUS_POINTS_NOT_ENOUNGH = 'titik tidak cukup untuk operasi ini, tidak ada titik akan dikeluarkan sementara'

    /**
     * =================================================
     * 智写云笔手写板
     * =================================================
     */
    exports.TIP_HAND_WRITTING_BOARD_CONNECTED = 'tablet terhubung dengan sukses'

    exports.TIP_HAND_WRITTING_BOARD_DISCONNECTED = 'tablet terputus'

    exports.TIP_HAND_WRITTING_BOARD_SLEEP
        = 'tabletnya tidur. silakan tekan tombol daya pada tablet luar untuk membangunkan perangkat'

    exports.CONFIRM_TITLE_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = 'tanda sistem'

    exports.CONFIRM_CONTENT_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = 'do you want to disconnect from the external tablet'

    exports.CANVAS_SWITCH_TO_WHITEBOARD = 'tukar ke papan putih'

    exports.CANVAS_SWITCH_TO_DOCUMENT = 'Beralih ke perangkat kursus: ${name}'

    /**
     * =================================================
     * 抢答器
     * =================================================
     */

    exports.TIP_USER_OFFLINE = 'murid itu tidak di kelas'

    exports.TIP_USER_ON_STAGE_ALREADY = 'pelajar telah makan gandum'

    exports.TIP_NOT_ALLOW_SPEAK = 'Transmisi langsung saat ini tidak mendukung permainan'

    /**
     * =================================================
     * 检测录制
     * =================================================
     */
    exports.TIP_RECORD_SOFTWARE_CHECKED
        = 'Program mendeteksi bahwa Anda merekam layar. Silakan tutup perangkat lunak merekam layar dan memulai ulang klien untuk melihat'

    /**
     * =================================================
     * 转播
     * =================================================
     */
    exports.INFO_CAN_NOT_OPERATE_MEDIA_WHEN_TRANSFER_CLASS
        = 'Audio dan video dan tindakan terkait courseware tidak dapat dioperasikan selama transmisi ulang'

    exports.CONFIRM_END_TRANSFER_CLASS = 'siarannya aktif. / yakin mematikan relai?'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_TRANSFER_CLASS_END
        = 'anda tidak dapat menggunakan media untuk memutar sampai anda mengakhiri siaran'

    exports.INFO_CAN_NOT_START_TRANSFER_CLASS_BEFORE_START_CLASS
        = 'pelajaran belum dimulai dan tidak dapat menggunakan relay ~'

    exports.CAN_NOT_STOP_RTMP_PUSH_WHEN_TRANSFER_CLASS_BEGIN = 'Fungsi siaran tidak dapat dilarang'

    exports.COMMON_ERROR_PAGE_TIP_PREFIX = ''

    /**
     * =================================================
     * 打开摄像头提示
     * =================================================
     */
    exports.INFO_IF_OPEN_CAMERA = 'Apakah kamera hidup?'

    exports.BUTTON_NOT_OPEN_CAMERA = 'Tidak terbuka'

    exports.BUTTON_OPEN_CAMERA = 'buka'

    /**
     * =================================================
     * 字幕
     * =================================================
     */
    exports.BUTTON_CAPTION = 'Sub indo oleh lovelysuju'

    exports.BUTTON_CLOSE_CAPTION = 'Tutup keterangan'

    /**
     * =================================================
     * 福袋
     * =================================================
     */
    exports.TIP_END_LUCKY_BAG = 'Fuosbags tidak akan bisa melanjutkan'

    /**
     * =================================================
     * PK 功能
     * =================================================
     */
    exports.TIP_PK_USER_NOT_ENOUGH = 'Dan mai di atas cukup rendah'

    exports.TIP_PK_USER_OUT = 'Sudah keluar dari kelas, silakan reset anggota PK'

    /**
     * =================================================
     * 打开网页
     * =================================================
     */
    exports.TIP_CLOSE_WEB_PAGE = 'menutup jendela akan mengambil kembali halaman siswa. apakah anda ingin melanjutkan?'

    exports.TIP_PAGE_CANCEL = 'halaman telah ditutup'

    exports.MANAGE_EXPLORER = 'pelayar'

    exports.ELECTRON_CLIENT_AVSDK_CAN_NOT_PUSH_STREAM_TIP = 'Versi Electron tidak didukung untuk menggunakan dorongan bawah video suara saat ini, silakan pergi ke web untuk mengunduh versi CEF!'

    /**
     * =================================================
     * 白板导出
     * =================================================
     */
    exports.BLACKBOARD_EXPORT = 'simpan papan tulis'

    /**
     * =================================================
     * 自定义推流布局
     * =================================================
     */
    exports.VIDEO_LAYOUT_SETTING = 'Pielāgots izkārtojum'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_VIDEO_LAYOUT = 'Anda tidak dapat menggunakan media sebelum tutup bentangan stream gubahan'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_VIDEO_LAYOUT = 'Anda tidak dapat menggunakan layar untuk berbagi sebelum tutup bentangan stream gubahan'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_SCREEN_SHARE = 'Tidak dapat menggunakan bentangan strim suai sebelum skrin dikongsi'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_MEDIA_FILE = 'Tidak dapat menggunakan bentangan strim suai sebelum video ditutup'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_PLAYBACK = 'Tidak dapat menggunakan bentangan push suai sebelum tutup main balik'

    exports.INFO_PUBLISH_VIDEO_LAYOUT_SHOULD_BE_PRESENTER = 'Hanya pembicara utama yang dapat menggunakan bentangan arus push suai'

    /**
     * =================================================
     * 切换 WebRTC 节点
     * =================================================
     */
    exports.BUTTON_SWITCH_WEBRTC_NODE = 'Tukar nod WebRTC'

    exports.INFO_CAN_NOT_SWITCH_WEBRTC_NODE_IN_WEBRTC_MIX = 'Anda tidak dapat mengganti node WebRTC selama WebRTC campuran'

    /**
     * =================================================
     * 本地录制提示
     * =================================================
     */
    exports.INFO_CONFIRM_STOP_LOCAL_RECORD = 'Rekaman lokal sedang dilakukan. Anda yakin ingin menghentikan rekaman lokal?'

    exports.INFO_LOCAL_RECORD_GENERATE = 'Generasi video rekaman lokal sedang dalam proses dan tidak dapat meninggalkan ruang siaran langsung.'

    exports.INFO_LOCAL_RECORD_HAS_GENERATE = 'Video yang direkam lokal telah dihasilkan.'

    /**
     * =================================================
     *  推荐卡片
     * =================================================
     */
    exports.TITLE_RECOMMEND_CARD = 'Kartu rekomendasi'

    /**
     * =================================================
     *  申请开麦
     * =================================================
     */
    exports.MIC_APPLY_DESC = 'Anda ingin membuka mikrofon, silakan tunggu persetujuan guru'
    
    exports.MIC_REJECT_TIP = 'Guru menolak permintaan Anda untuk membuka mikrofon'

    exports.MIC_ACCEPT_TIP = 'Guru menerima permintaan Anda untuk membuka mikrofon'

    exports.TIP_ON_WALL = 'Pesan Anda telah dipilih untuk ditempatkan di papan tulis!'

    /**
     * =================================================
     *  cpu 提示
     * =================================================
     */
    exports.TIP_CPU_HIGH_LIMIT_SCREEN_SHARE = 'Sistem mendeteksi lebih dari 70% CPU saat ini, menggunakan "berbagi layar" akan menyebabkan siaran langsung yang luar biasa, tidak didukung untuk diaktifkan!'

    exports.TIP_CPU_HIGH_LIMIT_BEAUTY = 'Sistem mendeteksi CPU saat ini lebih dari 70%, mengaktifkan "keindahan / latar belakang virtual" akan menyebabkan siaran langsung abnormal, tidak didukung untuk mengaktifkan!'

    exports.TIP_CPU_HIGH_END_SCREEN_SHARE = 'Sistem mendeteksi lebih dari 80% CPU saat ini, menggunakan "berbagi layar" akan menyebabkan siaran langsung yang luar biasa, dan berbagi telah terganggu untuk Anda!'

    exports.TIP_CPU_HIGH_END_BEAUTY = 'Sistem mendeteksi lebih dari 80% CPU saat ini, terus menggunakan "keindahan / latar belakang virtual" akan menyebabkan anomali siaran langsung, yang telah ditutup untuk Anda!'
})
